<template>
  <div>
    <div class="card printhide">
      <div class="content inset" @click="$parent.storeAdmin" @keyup="$parent.storeAdmin">
        <span style="float:right">
          Startdatum intake
          {{ new Date(new Date($parent.created).setHours(1)).toLocaleDateString() }}
        </span>
        <button @click="pushToCRM" v-if="Number($store.state.client) === 1">Push to CRM</button>
        <h2 class="title">
          <awesomeIcon icon="cog" /> Instellingen
        </h2>
        <changeuser ref="cu" />
        <div class="msg valid btns-right">
          Gebruiker <b>{{ $parent.email }}</b>
          {{ $parent.port ? `(Port ${$parent.port})` : '' }}
          <button
            @click="sendWelcome"
            v-if="$parent.isOfferMail"
          >
            Indicatie nogmaals versturen
          </button>
          <button
            @click="linkOriginal"
            v-if="$parent.redo && $parent.email != $parent.previousEmail"
          >
            Koppel originele gebruiker ({{ $parent.previousEmail }})
          </button>
          <button @click="$refs.cu.changing = true">
            Koppel andere gebruiker
          </button>
        </div>

        <div class="subheader">
          {{ $parent.intake.rekeningData.type }} instellingen
        </div>
        <div
          v-if="$parent.status === 'Geannuleerd' && $parent.intake.delete"
          class="flex-container flex-grow"
        >
          <customInput
            v-model="$parent.intake.delete"
            :disabled="true"
            type="text"
            class="flex-100"
            label="Reden van verwijderen"
            :validation="['notrequired']"
          />
        </div>
        <div class="flex-container flex-grow">
          <customInput
            ref="focus"
            v-model="modelValue.crmID"
            type="text"
            :label="'CRM nummer'"
            :validation="['notrequired']"
          />
          <customInput
            v-model="modelValue.beleggen.brand"
            type="dropdown"
            label="Merk"
            :options="[
              { label: 'Doelbeleggen', value: 'Doelbeleggen' },
              { label: 'OXBY', value: 'OXBY' },
              { label: 'Velthuyse &amp; Mulder', value: 'VMVB' },
              { label: 'Beer &amp; Van Stapele', value: 'BVS' },
            ]"
          />
          <customInput
            v-model="modelValue.beleggen.type"
            type="dropdown"
            label="Dienst"
            :options="[
              { label: 'Beheer', value: 'beheer' },
              { label: 'Advies', value: 'advies' },
              { label: 'Order executie', value: 'executie' },
              { label: 'Geblokkeerd', value: 'geblokkeerd' },
            ]"
          />
        </div>

        <div class="flex-container flex-grow">
          <customInput
            v-model="modelValue.rekening.bank"
            type="dropdown"
            label="Depotbank"
            :options="[
              { label: 'Giro', value: 'GIRO' },
              { label: 'Gili', value: 'GILI' },
              { label: 'Binck', value: 'BNCK' },
              { label: 'ABN Amro', value: 'AAB' },
              { label: 'Baloise', value: 'BAL' },
              { label: 'Saxo', value: 'SAXO' },
              { label: 'Van Lanschot', value: 'VLB' },
            ]"
          />
          <customInput
            v-model="modelValue.beleggen.report"
            type="dropdown"
            label="Rapportagefrequentie"
            :options="[
              { label: 'Nooit', value: '0' },
              { label: '1x per maand', value: '1' },
              { label: '1x per kwartaal', value: '3' },
              { label: '1x per jaar', value: '12' },
            ]"
            :validation="['notrequired']"
          />
          <customInput
            v-model="modelValue.beleggen.contact"
            type="dropdown"
            label="Contactfrequentie"
            :options="[
              { label: '1x per jaar', value: '1p12mnd' },
              { label: '1x per halfjaar', value: '1p6mnd' },
              { label: '1x per vier maanden', value: '1p4mnd' },
              { label: '1x per kwartaal', value: '1p3mnd' },
              { label: '1x per twee maanden', value: '1p2mnd' },
              { label: '1x per maand', value: '1p1mnd' },
              { label: 'Geen', value: '0p1mnd' },
            ]"
            :validation="[
              modelValue.beleggen.brand === 'Doelbeleggen' || modelValue.beleggen.brand === 'OXBY'
                ? 'notrequired'
                : ''
            ]"
          />
        </div>
        <div class="flex-container flex-grow">
          <customInput
            v-model="modelValue.rekeningStatus"
            type="dropdown"
            label="Rekening status"
            :options="[
              { label: 'Actief', value: null },
              { label: 'Bevroren', value: 'Bevroren' },
              { label: 'Gesloten', value: 'Gesloten' },
              { label: 'Pauze', value: 'Pauze' },
            ]"
            :validation="['notrequired']"
          />
          <customInput
            v-if="modelValue.rekeningStatus === 'Gesloten'"
            v-model="modelValue.rekeningGeslotenReden"
            type="dropdown"
            label="Reden rekening gesloten"
            :options="[
              { label: 'Alles bij 1 partij', value: 'AllesBij1Partij' },
              { label: 'Ander doel beleggingen', value: 'AnderDoel' },
              { label: 'Geld nodig', value: 'GeldNodig' },
              { label: 'Gezondheid', value: 'Gezondheid' },
              { label: 'hoogte kosten', value: 'HoogteKosten' },
              { label: 'Ontrevreden over rendement', value: 'OntevredenRendement' },
              { label: 'Overig', value: 'Overig' },
              { label: 'Overleden', value: 'Overleden' },
              { label: 'Wil niet meer beleggen', value: 'NietMeerBeleggen' },
              { label: 'Zelf doen', value: 'ZelfDoen' },
              { label: 'Opbouw naar uitkeren', value: 'OpbouwNaarUitkeren' }
            ]"
            :validation="['notrequired']"
          />
          <customInput
            v-if="
              modelValue.rekeningStatus === 'Gesloten'
              && modelValue.rekeningGeslotenReden === 'Overig'
            "
            v-model="modelValue.reneningGeslotenRedenOverig"
            type="text"
            label="Toelichting reden gesloten"
            :validation="['notrequired']"
          />
          <customInput
            v-if="
              modelValue.beleggen.brand === 'VMVB'
              || modelValue.beleggen.brand === 'BVS'
            "
            :hasDate="true"
            v-model:dateValue="modelValue.beleggen.geenOptiesDate"
            v-model="modelValue.beleggen.geenOpties"
            type="yesno2"
            label="Wilt niet in opties handelen"
            :validation="['notrequired']"
          />
          <customInput
            v-if="
              modelValue.beleggen.brand === 'VMVB'
              || modelValue.beleggen.brand === 'BVS'
            "
            :hasDate="true"
            v-model:dateValue="modelValue.beleggen.optiedalingMeldingDate"
            v-model="modelValue.beleggen.optiedalingMelding"
            type="yesno2"
            label="Wilt wel 10% optiedaling melding"
            :validation="['notrequired']"
          />
          <customInput
            v-if="
              modelValue.beleggen.brand === 'VMVB'
              || modelValue.beleggen.brand === 'BVS'
            "
            :hasDate="true"
            v-model:dateValue="modelValue.beleggen.debetstandDate"
            v-model="modelValue.beleggen.debetstand"
            type="yesno2"
            label="Accepteert debetstand"
            :validation="['notrequired']"
          />
          <customInput
            v-model="modelValue.tweedeIBANtype"
            type="dropdown"
            label="Status tweede IBAN"
            :options="[
              { label: 'Inkomend', value: undefined },
              { label: 'Uitgaand', value: 'Uitgaand' },
            ]"
            :validation="['notrequired']"
          />
          <customInput
            v-model="modelValue.tweedeIBAN"
            type="text"
            label="Tweede IBAN"
            :validation="['notrequired', 'iban']"
          />
        </div>

        <div class="flex-container flex-grow">
          <customInput
            v-model="modelValue.beleggen.manager"
            type="dropdown"
            label="Beheerder"
            :options="labels"
            @changed="setManagerName"
          />
          <customInput
            v-model="modelValue.beleggen.sales"
            type="dropdown"
            label="Adviseur"
            :options="labelsAtp"
            @changed="setSalesName"
          />
        </div>

        <div
          v-if="
            modelValue.beleggen.brand === 'Doelbeleggen'
            || modelValue.beleggen.brand === 'OXBY'
          "
          class="flex-container flex-grow"
        >
          <customInput
            v-model="modelValue.beleggen.keepManager"
            type="yesno"
            label="Behoud beheerder als eigenaar van de vragenlijst"
          />
        </div>

        <p class="subheader">
          Fee overzicht
        </p>
        <div class="flex-container flex-grow">
          <customInput
            v-model="modelValue.beleggen.feeName"
            type="dropdown"
            label="Fee type"
            :options="$parent.feeoptions"
            class="flex-33"
            @changed="changeFee"
          />
          <customInput
            :disabled="modelValue.beleggen.feeLocked"
            v-model="modelValue.beleggen.feeFixed"
            type="money"
            class="flex-33"
            label="Fixed fee"
            :validation="['notrequired']"
            :readOnly="modelValue.beleggen.feeLocked ? true : false"
          />
          <customInput
            v-model="modelValue.beleggen.feeBtw"
            type="yesno"
            class="flex-33"
            label="BTW"
          />
        </div>
        <div class="flex-container flex-grow">
          <customInput
            :disabled="modelValue.beleggen.feeLocked"
            v-model="modelValue.beleggen.feeAmount1"
            type="feePercentage"
            label="Beheer fee 0k - 250k"
            :validation="['notrequired']"
            :readOnly="modelValue.beleggen.feeLocked ? true : false"
          />
          <customInput
            :disabled="modelValue.beleggen.feeLocked"
            v-model="modelValue.beleggen.feeAmount2"
            type="feePercentage"
            label="Beheer fee 250k - 500k"
            :validation="['notrequired']"
            :readOnly="modelValue.beleggen.feeLocked ? true : false"
          />
        </div>
        <div class="flex-container flex-grow">
          <customInput
            :disabled="modelValue.beleggen.feeLocked"
            v-model="modelValue.beleggen.feeAmount3"
            type="feePercentage"
            label="Beheer fee 500k - 1m"
            :validation="['notrequired']"
            :readOnly="modelValue.beleggen.feeLocked ? true : false"
          />
          <customInput
            :disabled="modelValue.beleggen.feeLocked"
            v-model="modelValue.beleggen.feeAmount4"
            type="feePercentage"
            label="Beheer fee 1m+"
            :validation="['notrequired']"
            :readOnly="modelValue.beleggen.feeLocked ? true : false"
          />
        </div>
        <div class="flex-container flex-grow">
          <customInput
            :disabled="modelValue.beleggen.feeLocked"
            v-model="modelValue.beleggen.feePerformance"
            type="feePercentage"
            class="flex-33"
            label="Performance fee"
            :validation="['notrequired']"
            :readOnly="modelValue.beleggen.feeLocked ? true : false"
          />
          <customInput
            :disabled="modelValue.beleggen.feeLocked"
            v-model="modelValue.beleggen.feeWatermarkPeriod"
            type="number"
            class="flex-33"
            label="Watermark (maanden)"
            :validation="['notrequired']"
            :readOnly="modelValue.beleggen.feeLocked ? true : false"
          />
          <customInput
            v-model="modelValue.beleggen.feeMinimalWatermark"
            type="money"
            class="flex-33"
            label="Minimale watermark (Optioneel)"
            :validation="['notrequired']"
          />
        </div>
        <div class="flex-container flex-grow">
          <customInput
            v-model="modelValue.beleggen.feeMainWallet"
            type="text"
            class="flex-50"
            label="Hoofd portefeuille (Optioneel)"
            :validation="['notrequired']"
          />
          <customInput
            v-model="modelValue.beleggen.feeAdminPayment"
            :disabled="modelValue.beleggen.feeLocked"
            type="feePercentage"
            class="flex-50"
            label="Admin uitkeringskosten"
            :validation="['notrequired']"
            :readOnly="modelValue.beleggen.feeLocked ? true : false"
          />
        </div>
        <div class="flex-container flex-grow">
          <form>
            <textarea
              id="note_fee"
              @change="update" @paste="update"
              v-model="modelValue.beleggen.feeNote"
              placeholder="Fee opmerking..."
              rows="4"
              style="margin-top:10px"
              autofocus
              :validation="['notrequired']"
            />
          </form>
        </div>

        <div v-if="$parent.intake.atpData && $parent.intake.atpData.connected">
          <p class="subheader">
            ATP vergoeding overzicht
          </p>
          <div class="flex-container flex-grow">
            <customInput
              v-model="$parent.intake.atpData.email"
              label="E-mail klant"
              type="text"
              :disabled="true"
            />
            <customInput
              v-model="$parent.intake.atpData.kosten"
              label="Vergoeding(en)"
              type="yesno"
              :disabled="!($parent.status === 'Ingeleverd' || $parent.status === 'Bezig')"
            />
          </div>
          <div v-if="$parent.intake.atpData.kosten === 'Yes'" class="flex-container flex-grow">
            <customInput
              v-model="$parent.intake.atpData.vergoedingEenmalig"
              type="money"
              label="Vergoeding eenmalig"
              placeholder="€"
              :validation="['notrequired']"
              :disabled="!($parent.status === 'Ingeleverd' || $parent.status === 'Bezig')"
            />
            <customInput
              v-model="$parent.intake.atpData.vergoedingJaar"
              type="money"
              label="Vergoeding per jaar (€)"
              :validation="['notrequired']"
              placeholder="€"
              :disabled="!($parent.status === 'Ingeleverd' || $parent.status === 'Bezig')"
            />
            <customInput
              v-model="$parent.intake.atpData.vergoedingPercentageJaar"
              type="percentage"
              :validation="['notrequired']"
              label="Vergoeding per jaar (%)"
              :disabled="!($parent.status === 'Ingeleverd' || $parent.status === 'Bezig')"
            />
          </div>
        </div>

        <!-- Old intake audit log -->
        <div class="subheader">
          Intake Audit log (oud)
          <span @click="showOldLogs = !showOldLogs" class="showtoggle">
            <awesomeIcon :icon="showOldLogs ? 'chevron-down' : 'chevron-up'" />
          </span>
        </div>
        <div v-if="showOldLogs" class="flex-container flex-grow">
          <table class="new persontable">
            <tr>
              <th>Actie</th>
              <th>Door</th>
              <th>Op</th>
            </tr>
            <tr v-if="$parent.userOverview.create_client">
              <td>Aangemaakt</td>
              <td>
                {{
                  find($parent.users, {
                    id: parseInt($parent.userOverview.create_client)
                  }) ? find($parent.users, {
                    id: parseInt($parent.userOverview.create_client)
                  }).email : 'onbekend'
                }}
              </td>
              <td>
                {{ new Date($parent.userOverview.create_date).toLocaleDateString() }}
                {{ new Date($parent.userOverview.create_date).toLocaleTimeString() }}
              </td>
            </tr>
            <tr
              v-for="offer in filter(
                $parent.intake.offers,
                (o) => !o.deleted
                  && $parent.intakeAdmin.offers[o.offerId]
                  && $parent.intakeAdmin.offers[o.offerId].calculated
              )"
              :key="`calculated-${offer.offerId}`"
            >
              <td>Indicatie #{{offer.offerId}} berekend</td>
              <td>
                {{
                  find(
                    $parent.users,
                    {id: parseInt($parent.intakeAdmin.offers[offer.offerId].user)}
                  )
                  ? find(
                    $parent.users,
                    {id: parseInt($parent.intakeAdmin.offers[offer.offerId].user)}
                  ).email
                  : 'onbekend'
                }}
              </td>
              <td>
                {{
                  new Date(
                    $parent.intakeAdmin.offers[offer.offerId].calculatedDate
                  ).toLocaleDateString()
                }}
                {{
                  new Date(
                    $parent.intakeAdmin.offers[offer.offerId].calculatedDate
                  ).toLocaleTimeString()
                }}
              </td>
            </tr>
            <tr
              v-for="offer in filter(
                $parent.intake.offers,
                (o) => !o.deleted
                  && o.selected
                  && $parent.intakeAdmin.offers[o.offerId]
              )"
              :key="`selected-${offer.offerId}`"
            >
              <td>Indicatie #{{offer.offerId}} geselecteerd</td>
              <td>
                {{
                  find(
                    $parent.users,
                    {id: parseInt($parent.intakeAdmin.offers[offer.offerId].user)}
                  )
                  ? find(
                    $parent.users,
                    {id: parseInt($parent.intakeAdmin.offers[offer.offerId].user)}
                  ).email
                  : 'onbekend'
                }}
              </td>
              <td>
                {{
                  new Date(
                    offer.selectedDate
                  ).toLocaleDateString()
                }}
                {{
                  new Date(
                    offer.selectedDate
                  ).toLocaleTimeString()
                }}
              </td>
            </tr>
            <tr v-if="$parent.userOverview.send_client">
              <td>Ingeleverd</td>
              <td>
                {{
                  find($parent.users, {
                    id: parseInt($parent.userOverview.send_client)
                  }) ? find($parent.users, {
                    id: parseInt($parent.userOverview.send_client)
                  }).email : 'onbekend'
                }}
              </td>
              <td>
                {{ new Date($parent.userOverview.send_date).toLocaleDateString() }}
                {{ new Date($parent.userOverview.send_date).toLocaleTimeString() }}
              </td>
            </tr>
            <tr v-if="$parent.userOverview.accept_client">
              <td>Geaccepteerd</td>
              <td>
                {{
                  find($parent.users, {
                    id: parseInt($parent.userOverview.accept_client)
                  }) ? find($parent.users, {
                    id: parseInt($parent.userOverview.accept_client)
                  }).email : 'onbekend'
                }}
              </td>
              <td>
                {{ new Date($parent.userOverview.accept_date).toLocaleDateString() }}
                {{ new Date($parent.userOverview.accept_date).toLocaleTimeString() }}
              </td>
            </tr>
            <tr v-if="$parent.userOverview.sign_client">
              <td>Ondertekend</td>
              <td>
                {{
                  find($parent.users, {
                    id: parseInt($parent.userOverview.sign_client)
                  }) ? find($parent.users, {
                    id: parseInt($parent.userOverview.sign_client)
                  }).email : 'onbekend'
                }}
              </td>
              <td>
                {{ new Date($parent.userOverview.sign_date).toLocaleDateString() }}
                {{ new Date($parent.userOverview.sign_date).toLocaleTimeString() }}
              </td>
            </tr>
            <tr v-if="$parent.userOverview.complete_client">
              <td>Afgerond</td>
              <td>
                {{
                  find($parent.users, {
                    id: parseInt($parent.userOverview.complete_client)
                  }) ? find($parent.users, {
                    id: parseInt($parent.userOverview.complete_client)
                  }).email : 'onbekend'
                }}
              </td>
              <td>
                {{ new Date($parent.userOverview.complete_date).toLocaleDateString() }}
                {{ new Date($parent.userOverview.complete_date).toLocaleTimeString() }}
              </td>
            </tr>
          </table>
        </div>

          <!-- New intake audit log -->
        <p class="subheader">
          Intake Audit log
        </p>
        <div class="flex-container flex-grow" style="overflow:scroll">
          <table class="new">
            <tr>
              <th>Actie</th>
              <th>Naam</th>
              <th>E-mail</th>
              <th>Op</th>
              <th>Ip-adres</th>
            </tr>
            <tr v-for="(intake, index) in intakeLogs" :key="index">
              <td>{{ intake.type }}</td>
              <td v-if="intake.become">
                {{ find($parent.users, { id: Number(intake.become) }).name }}
                <br />
                namens {{ intake.name }}
              </td>
              <td v-else> {{ intake.name }}</td>
              <td v-if="intake.become">
                {{ find($parent.users, { id: Number(intake.become) }).email }}
                <br />
                namens {{ intake.email }}
              </td>
              <td v-else> {{ intake.email }}</td>
              <td>{{ new Date(intake.date).toLocaleString() }}</td>
              <td>{{ intake.ip }}</td>
            </tr>
          </table>
          <template v-if="activeOffers">
            <p class="subheader" style="margin-top: 10px">
              Offerte log
            </p>
            <table class="new persontable">
              <tr>
                <th>Actie</th>
                <th>Door</th>
                <th>Op</th>
              </tr>
              <tr
                v-for="offer in filter(
                  $parent.intake.offers,
                  (o) => !o.deleted
                    && $parent.intakeAdmin.offers[o.offerId]
                    && $parent.intakeAdmin.offers[o.offerId].calculated
                )"
                :key="`calculated-${offer.offerId}`"
              >
                <td>Indicatie #{{offer.offerId}} berekend</td>
                <td>
                  {{
                    find(
                      $parent.users,
                      {id: parseInt($parent.intakeAdmin.offers[offer.offerId].user)}
                    )
                    ? find(
                      $parent.users,
                      {id: parseInt($parent.intakeAdmin.offers[offer.offerId].user)}
                    ).email
                    : 'onbekend'
                  }}
                </td>
                <td>
                  {{
                    new Date(
                      $parent.intakeAdmin.offers[offer.offerId].calculatedDate
                    ).toLocaleDateString()
                  }}
                  {{
                    new Date(
                      $parent.intakeAdmin.offers[offer.offerId].calculatedDate
                    ).toLocaleTimeString()
                  }}
                </td>
              </tr>
              <tr
                v-for="offer in filter(
                  $parent.intake.offers,
                  (o) => !o.deleted
                    && o.selected
                    && $parent.intakeAdmin.offers[o.offerId]
                )"
                :key="`selected-${offer.offerId}`"
              >
                <td>Indicatie #{{offer.offerId}} geselecteerd</td>
                <td>
                  {{
                    find(
                      $parent.users,
                      {id: parseInt($parent.intakeAdmin.offers[offer.offerId].user)}
                    )
                    ? find(
                      $parent.users,
                      {id: parseInt($parent.intakeAdmin.offers[offer.offerId].user)}
                    ).email
                    : 'onbekend'
                  }}
                </td>
                <td>
                  {{
                    new Date(
                      offer.selectedDate
                    ).toLocaleDateString()
                  }}
                  {{
                    new Date(
                      offer.selectedDate
                    ).toLocaleTimeString()
                  }}
                </td>
              </tr>
            </table>
          </template>

        </div>

      </div>
    </div>

    <!-- change to u person -->
    <modalWindow
      v-show="changePersonModal"
      @close="changePersonModal = false;"
      :bgtrigger="false"
    >
      <div class="titlebar">Wijzig de rekeninghouder</div>
      <div class="inset">
        U heeft aangegeven dat de U persoon overleden is, kies alstublieft een nieuwe U persoon.
        <template v-for="(person, i) in $parent.intake.persoonsData">
            <button
              :key="i"
              v-if="i != 0 && !person.sterfteDatum"
              @click="setNewUPerson(i)"
              style="float:right; margin-bottom: 10px;"
            >
              Persoon #{{i+1}}
              {{ person.voorletters ? `${person.voorletters} ` : '' }}
              {{ person.tussenvoegsel ? `${person.tussenvoegsel} ` : '' }}
              {{ person.achternaam ? person.achternaam : '' }}
          </button>
        </template>
      </div>
    </modalWindow>
    <!-- psk form -->
    <modalWindow
      v-show="pskFormToggle"
      @close="pskFormToggle = false; selectedPsk = {};"
      width="860"
      position="edge"
    >
      <div class="titlebar">Overdrachtsformulier</div>
      <div class="viewport">
        <pskForm
          :currentPsk="selectedPsk"
          :intake="$parent.intake"
          :email="$parent.email"
          :id="$parent.id"
          :port="$parent.port"
        />
      </div>
      <div class="modalfooter">
        <span
          v-if="
            `${location}`.indexOf('http://') === -1 && `${location}`.indexOf('https://') === -1
          "
        >
          Printen is alleen mogelijk vanuit de site
        </span>
        <button style="float:right" @click="windowPrint" v-else>
          Printen <awesomeIcon icon="print" />
        </button>
      </div>
    </modalWindow>
    <div class="card printhide">
      <div class="content inset" @change="$parent.storeAdmin();">
        <modalWindow v-if="openMessage" @close="openMessage = false" width="400">
          <div class="titlebar">Bericht</div>
          <div class="inset">
            Onderstaand bericht wordt in de online berichtenbox van <b>{{$parent.email}}</b>
            geplaatst. De klant ontvangt een geautomatiseerde mail dat er een bericht klaarstaat.
            <br /><br />
            <div style="padding: 10px; border: 1px solid black;">
             <b>{{messageTitle}}</b> <br /><br />
             <span v-html="messageBody" />
            </div>
            <button @click="sendMessage()">
              Bericht plaatsen/versturen
            </button>
          </div>
        </modalWindow>
        <button @click="openMessage = !openMessage" style="float:right">
          <awesomeIcon icon="envelope"/> Plaats/verstuur bericht naar klant
        </button>
        <h2 class="title">
          <awesomeIcon icon="address-card" /> Customer Due Diligence
        </h2>

        <div v-if="$parent.userExtraPorts.length > 0" class="msg" style="margin-top: 10px">
            Heeft meerdere doelen ({{$parent.userExtraPorts.join(', ')}})
        </div>
        <div v-if="parsedCddErrors.length > 0" class="msg error">
          CDD heeft nog <b>{{parsedCddErrors.length}}</b>
          {{parsedCddErrors.length === 1 ? 'kwestie' : 'kwesties'}}.
          <button
            v-if="parsedCddErrors.length > 0"
            @click="showErrors = !showErrors"
            style="float: right; cursor: pointer;"
            class="no-padding"
          >
            {{showErrors ? 'Sluit' : 'Bekijk'}} kwesties
            <awesomeIcon :icon="showErrors ? 'eye-slash' : 'eye'" />
          </button>
          <template v-if="showErrors">
            <div v-for="(error, index) in parsedCddErrors"
              :key="index" style="padding-top: 10px"
            >
            <button
              @click="focusedError = error.uid"
              class="no-padding"
              style="margin: 5px 5px 0px 0px; cursor: pointer;"
            >
              <awesomeIcon :icon=" error.state === 'invalid' ? 'times' : 'exclamation-circle'"/>
              {{error.description}}
              {{error.userIndex === null
                ? ''
                : `voor ${$parent.intake.persoonsData[error.userIndex].roepnaam
                  ? $parent.intake.persoonsData[error.userIndex].roepnaam
                  : ''}
                ${$parent.intake.persoonsData[error.userIndex].tussenvoegsel
                  ? $parent.intake.persoonsData[error.userIndex].tussenvoegsel
                  : ''}
                ${$parent.intake.persoonsData[error.userIndex].achternaam
                  ? $parent.intake.persoonsData[error.userIndex].achternaam
                  : ''}`
              }}
              {{error.state === 'invalid' ? 'heeft geen akkoord' : 'is nog niet ingevuld'}}
            </button>
          </div>
          </template>
        </div>
        <div class="msg" style="margin-bottom:20px; margin-top:2px;">
          <button
            @click="noteToggle = !noteToggle"
            class="no-padding"
            style="float:right"
          >
            {{
              noteToggle
                ? "Opslaan"
                : modelValue.note
                ? ""
                : "Cdd notitie"
            }}
            <awesomeIcon icon="edit" v-if="!noteToggle" />
            <awesomeIcon icon="chevron-up" v-if="noteToggle" />
          </button>
          <span
            v-if="!noteToggle && modelValue.note != ''"
            style="display:inline-block; max-width:95%;"
          >
            {{ modelValue.note }}
          </span>
          <form
            v-if="noteToggle"
            @submit.prevent
          >
            <textarea
              id="note_admin_message"
              @change="update" @paste="update"
              v-model="modelValue.note"
              placeholder="Cdd notitie..."
              rows="4"
              style="margin-top:10px"
              autofocus
            />
          </form>
        </div>

        <p class="subheader">
          Vergoeding (backoffice)
        </p>
        <cddcheck
          :cddkey="'feeadministration'"
          :description="`Vergoedingadministratie`"
          :options="[
            { value: 'Goed geadministreerd', state: 'valid' },
            { value: 'Niet correct', state: 'invalid' },
          ]"
        />

        <p class="subheader">
          Identificatiestorting
        </p>
        <div
          v-if="
            $parent.redo
            && $parent.intake.rekeningData.iban.replace(/\s/g, '').toUpperCase()
            != $parent.previousIntake.rekeningData.iban.replace(/\s/g, '').toUpperCase()
          "
          class="msg"
        >
          Let op, de tegenrekening is gewijzigd.
          <br />Oude rekeningnummer:
          {{$parent.previousIntake.rekeningData.iban.replace(/\s/g, '').toUpperCase()}},
          <br />nieuwe rekeningnummer:
          {{$parent.intake.rekeningData.iban.replace(/\s/g, '').toUpperCase()}}
        </div>
        <div class="content card" style="padding: 0 10px 10px; margin: 0;">
          <table class="new" style="margin-top: 10px">
            <tr>
              <th width="25%">Tenaamstelling</th>
              <td v-if="$parent.intake.rekeningData.type === 'Bedrijfsrekening'">
                {{ $parent.intake.bedrijfsData.bedrijfsnaam || "?" }}
              </td>
              <td v-else>
                {{join(
                    map(
                      filter(
                        $parent.intake.persoonsData,
                        $parent.financeFilter,
                      ),
                      (o) => `${o.voorletters || ''} ${o.tussenvoegsel || ''} ${o.achternaam || ''}`
                    ),
                   ' e/o ',
                   )
                  }}
              </td>
              <td colspan="2"></td>
            </tr>
            <tr>
              <th width="25%">Tegenrekening</th>
              <td>{{ $parent.intake.rekeningData.iban.toUpperCase() || "?" }}</td>
              <td colspan="2"></td>
            </tr>
            <tr>
              <th width="25%">Startbedrag</th>
              <td>&euro; {{ formatPrice($parent.intake.goalData.vermogen, true) }}</td>
              <td colspan="2"></td>
            </tr>
            <tr>
              <th width="25%"> Gestorte waarde</th>
              <td>&euro; {{ formatPrice($parent.value) }}</td>
              <td colspan="2"></td>
            </tr>
          </table>
          <br />
          <template
            v-if="filter(
              $parent.files,
              (o) => o.path.includes('accountcopy')
              ).length > 0
            ">
            <table class="new interactive">
              <thead>
                <tr>
                  <th>Geüploade bankafschriften</th>
                </tr>
              </thead>
              <tr v-for="file in filter(
                $parent.files,
                (o) => o.path.includes('accountcopy')
                )"
                :key="file.path"
              >
                <td @click="download(file.path)">
                  {{ file.path.substring(18 + prefix.length) }}
                </td>
              </tr>
            </table>
            <br />
          </template>
          <p
            v-for="(transaction, index) in filter(transactions, (o) => Number(o.status) == 2)"
            :key="index + 1
          ">
            #{{ index + 1 }} ({{ new Date(transaction.date).toLocaleString() }}) - &euro;
            {{ formatPrice(transaction.amount) }} door
              <b>{{ transaction.name }}</b> van
            <span :style="`${checkIban(transaction.iban) ? 'color: #59b300' : 'color: #b30000;'}`">
              <awesomeIcon :icon="checkIban(transaction.iban) ? 'check' : 'times'" />
              {{ transaction.iban }}
            </span>
            (Status {{ toStatus(transaction) }})
          </p>
          <cddcheck
            :cddkey="`bankregistration`"
            :description="`Identificatiestorting`"
            :options="[
              { value: 'Match', state: 'valid' },
              { value: 'Fysiek', state: 'valid' },
              { value: 'Geen match', state: 'invalid' },
              { value: 'E/o niet leesbaar', state: 'invalid' },
              { value: 'Geen Ned. Bank', state: 'invalid' },
            ]"
          />
        </div>

        <template v-if="$parent.intake.goalData.box === '1'">
          <p class="subheader">Herkomst kapitaal</p>
          <div
            v-if="$parent.intake.transferData.overdrachten.length > 0"
            class="content card"
            style="padding: 0 10px 10px; margin: 0;"
          >
            <div class="flex-container flex-grow">
              <div class="table-wrapper" style="margin-top: 10px">
                <table width=100%>
                  <thead class="table-legend">
                    <tr>
                      <th>Type</th>
                      <th>Port / IBAN / Polis</th>
                      <th>Instelling</th>
                      <th>Bedrag</th>
                      <th>Polisblad</th>
                      <th>Overdracht formulier</th>
                      <th>Ondertekend</th>
                      <th>PSK/bedrijf</th>
                    </tr>
                  </thead>
                  <tr
                    v-for="(overdracht, overdrachtIndex) in filter(
                      $parent.intake.transferData.overdrachten, 'bedrag'
                    )"
                    :key='overdrachtIndex'
                  >
                    <td v-if="overdracht.overdrachtType === 'intern'">
                      Intern
                    </td>
                    <td v-else>
                      {{ overdracht.overdrachtType === 'psk'
                        ? 'PSK'
                        : overdracht.overdrachtType === 'psk2'
                          ? 'Overig'
                          : overdracht.kapitaalType
                      }}
                    </td>
                    <td>
                      {{
                        overdracht.overdrachtType === 'psk'
                        ? overdracht.polisnummer
                        : overdracht.iban
                      }}
                    </td>
                    <td v-if="overdracht.overdrachtType === 'intern'">
                      Doelbeleggen
                    </td>
                    <td v-else>
                      {{
                        overdracht.instellingNaam === 'Anders'
                        ? overdracht.instellingNaamOmschrijving
                        : overdracht.instellingNaam
                      }}
                    </td>
                    <td>
                      &euro;&nbsp;{{ formatPrice(overdracht.bedrag, true)}}
                    </td>
                    <td
                      v-if="!filter(
                        $parent.files,
                        (o) => o.path.indexOf(
                          `overdrachten-${Number(overdracht.index)}-polis`
                        ) > -1,
                        ).length
                      ">
                      <awesomeIcon icon="times" color="red"/>
                    </td>
                    <td v-else>
                      <span v-for="(file, index) in filter(
                          $parent.files,
                          (o) => o.path.includes(
                            `overdrachten-${Number(overdracht.index)}-polis`
                          ),
                        )"
                        @click="download(filter(
                          $parent.files,
                          (o) => o.path.includes(
                            `overdrachten-${Number(overdracht.index)}-polis`
                          ),
                        )[index].path)"
                        :key="index"
                      >
                        <awesomeIcon
                          class="green"
                          style="cursor: pointer"
                          :title="`${filter(
                            $parent.files,
                            (o) => o.path.includes(
                              `overdrachten-${Number(overdracht.index)}-polis`
                            ),
                          )[0].path.substring(18 + prefix.length)}`"
                          icon="eye"
                        />
                      </span>
                    </td>

                    <td>
                      <span
                        v-if="overdracht.overdrachtType !== 'intern'
                          && (
                            overdracht.overdrachtType !== 'bv'
                            && overdracht.instellingNaam !== 'ASR'
                          )
                        "
                        @click="loadPsk(overdracht)"
                      >
                        <awesomeIcon
                          class="green"
                          style="cursor: pointer"
                          title="Overdrachtsformulier"
                          icon="eye"
                        />
                      </span>
                      <span v-else>
                        <awesomeIcon icon="times" />
                      </span>
                    </td>

                    <td
                      @click="download(filter(
                        $parent.files,
                        (o) => o.path.includes(
                          `overdrachten-${Number(overdracht.index)}-ondertekend`
                        ),
                      )[0].path)"
                      v-if="filter(
                        $parent.files,
                        (o) => o.path.indexOf(
                          `overdrachten-${Number(overdracht.index)}-ondertekend`
                        ) > -1,
                        ).length
                      "
                    >
                      <awesomeIcon
                        class="green"
                        style="cursor: pointer"
                        :title="`${filter(
                          $parent.files,
                          (o) => o.path.includes(
                            `overdrachten-${Number(overdracht.index)}-ondertekend`
                          ),
                        )[0].path.substring(18 + prefix.length)}`"
                        icon="eye"
                      />
                    </td>
                    <td v-else>
                      <customInput
                        style="background: none !important"
                        v-model="$parent.intake.transferData.overdrachten[
                          overdracht.index
                        ].files"
                        type="addFile"
                        :prefix="`overdrachten-${Number(overdracht.index)}-ondertekend`"
                        :validation="['notrequired']"
                        :fileDelete="false"
                      />
                    </td>

                    <td
                      @click="download(filter(
                        $parent.files,
                        (o) => o.path.includes(
                          `overdrachten-${Number(overdracht.index)}-akkoord`
                        ),
                      )[0].path)"
                      v-if="filter(
                        $parent.files,
                        (o) => o.path.indexOf(
                          `overdrachten-${Number(overdracht.index)}-akkoord`
                        ) > -1,
                        ).length
                      "
                    >
                      <awesomeIcon
                        class="green"
                        style="cursor: pointer"
                        :title="`${filter(
                          $parent.files,
                          (o) => o.path.includes(
                            `overdrachten-${Number(overdracht.index)}-akkoord`
                          ),
                        )[0].path.substring(18 + prefix.length)}`"
                        icon="eye"
                      />
                    </td>
                    <td v-else>
                      <customInput
                        style="background: none !important"
                        v-model="$parent.intake.transferData.overdrachten[
                          overdracht.index
                        ].files"
                        type="addFile"
                        :prefix="`overdrachten-${Number(overdracht.index)}-akkoord`"
                        :validation="['notrequired']"
                        :fileDelete="false"
                      />
                    </td>

                  </tr>
                  <tr v-if="
                    (
                      $parent.intake.goalData.type === 'pensioen'
                      || $parent.intake.goalData.type === 'netto-lijfrente-opbouwend'
                    )
                    && Number($parent.intake.goalData.vermogen)
                    - Number(sumBy(
                      filter($parent.intake.transferData.overdrachten, 'bedrag'),
                      o => Number(o.bedrag),
                    )) > 0
                  ">
                    <td> jaar/reserveringsruimte</td>
                    <td>Vaste tegenrekening</td>
                    <td colspan="2" />
                    <td>
                      &euro;&nbsp;{{
                        formatPrice(
                        Number($parent.intake.goalData.vermogen)
                        - Number(sumBy(
                          filter($parent.intake.transferData.overdrachten, 'bedrag'),
                          o => Number(o.bedrag),
                        )), true)
                      }}
                    </td>
                    <td colspan="5" />
                  </tr>
                </table>
                <p
                  class="msg"
                  v-if="
                    ( $parent.intake.goalData.type === 'pensioen'
                      || $parent.intake.goalData.type === 'netto-lijfrente-opbouwend'
                    )
                    && Number($parent.intake.goalData.vermogen)
                    - Number(sumBy(
                      filter($parent.intake.transferData.overdrachten, 'bedrag'),
                      o => Number(o.bedrag),
                    )) > 72550
                ">
                  <awesomeIcon icon="exclamation-circle" />
                  Het huidige bedrag (&euro;&nbsp;{{
                      formatPrice(
                        Number($parent.intake.goalData.vermogen)
                          - Number(sumBy(
                            filter($parent.intake.transferData.overdrachten, 'bedrag'),
                            o => Number(o.bedrag),
                          )), true)
                    }}) is wellicht hoger dan het bedrag dat maximaal aan jaar/reserveringsruimte
                    kan gebruikt worden (&euro;&nbsp;72.550,-).
                </p>
                <p
                  class="msg"
                  v-else-if="
                    ( $parent.intake.goalData.type === 'gouden-handdruk-opbouwend'
                      || $parent.intake.goalData.type === 'levensonderhoud'
                      || $parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
                      || $parent.intake.goalData.type === 'netto-lijfrente-uitkerend'
                    )
                    && Number($parent.intake.goalData.vermogen)
                    - Number(sumBy(
                      filter($parent.intake.transferData.overdrachten, 'bedrag'),
                        o => Number(o.bedrag),
                    )) < 0
                ">
                  <awesomeIcon icon="times" />
                  Het overdracht bedrag (&euro;&nbsp;{{
                    formatPrice(
                      Number(sumBy(
                      filter($parent.intake.transferData.overdrachten, 'bedrag'),
                      o => Number(o.bedrag),
                    )), true)
                  }}) is hoger dan de inleg (&euro;&nbsp;{{
                    formatPrice(Number($parent.intake.goalData.vermogen), true)
                  }}) die is ingevuld in het doel.
                </p>
                <p
                  class="msg"
                  v-else-if="
                    ( $parent.intake.goalData.type === 'gouden-handdruk-opbouwend'
                      || $parent.intake.goalData.type === 'levensonderhoud'
                      || $parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
                      || $parent.intake.goalData.type === 'netto-lijfrente-uitkerend'
                    )
                    && Number(sumBy(
                        filter($parent.intake.transferData.overdrachten, 'bedrag'),
                        o => Number(o.bedrag),
                      )) === 0
                ">
                  <awesomeIcon icon="times" />
                  Er zijn nog geen overdrachten, terwijl het gekozen doel wel overdrachten
                  verwacht.
                </p>
                <p
                  class="msg"
                  v-else-if="
                    ( $parent.intake.goalData.type === 'gouden-handdruk-opbouwend'
                      || $parent.intake.goalData.type === 'levensonderhoud'
                      || $parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
                      || $parent.intake.goalData.type === 'netto-lijfrente-uitkerend'
                    )
                    && Number($parent.intake.goalData.vermogen)
                    - Number(sumBy(
                      filter($parent.intake.transferData.overdrachten, 'bedrag'),
                        o => Number(o.bedrag),
                    )) > 0
                ">
                  <awesomeIcon icon="times" />
                  Het overdracht bedrag (&euro;&nbsp;{{
                    formatPrice(
                      Number(sumBy(
                      filter($parent.intake.transferData.overdrachten, 'bedrag'),
                      o => Number(o.bedrag),
                    )), true)
                  }}) is lager dan de inleg (&euro;&nbsp;{{
                    formatPrice(Number($parent.intake.goalData.vermogen), true)
                  }}) die is ingevuld bij het doel.
                </p>
              </div>
            </div>

            <template
              v-if="filter(
                  $parent.intake.transferData.overdrachten,
                  (o) =>
                    (o.overdrachtType === 'psk' || o.overdrachtType === 'psk2')
                    && Number(o.bedrag) > 0
                    && (
                      o.instellingNaam === 'NationaleNederlanden'
                      || o.instellingNaam === 'Scildon'
                    )
              ).length > 0"
            >
              <div class="subheader" style="margin-top: 20px">
                Kopie bankafschrift
              </div>
              <div
                class="file-row"
                v-for="file in filter(
                  $parent.files,
                  (o) => new RegExp(`kopie-bankafschrift`).test(o.path)
                )"
                :key="file.path"
              >
                <span>
                  {{file.path.substring(18 + prefix.length)}}
                </span>
                <a
                  v-if="(
                      $parent.role > 7
                      && ($parent.status === 'Ingeleverd' || $parent.status === 'Bezig')
                    )
                    || (!$parent.redo && $parent.status === 'Bezig')
                  "
                  class="file-button"
                  @click="remove(file.path)"
                >
                  Verwijder <awesomeIcon icon="times"/>
                </a>
                <a class="file-button" @click="download(file.path)">
                  Bekijken <awesomeIcon icon="eye"/>
                </a>
              </div>
            </template>

            <div v-if="$parent.files">
              <div class="subheader" style="margin-top: 20px !important">
                <awesomeIcon icon="file" /> Gekoppelde PSK bestanden
                <span
                  @click="showPskFiles = !showPskFiles"
                  style="float: right; cursor: pointer;"
                  class="no-padding"
                >
                  {{showPskFiles ? 'Sluit' : 'Bekijk'}} bestanden
                  <awesomeIcon :icon="showPskFiles ? 'eye-slash' : 'eye'" />
                </span>
              </div>
              <template v-if="showPskFiles">
                <div
                  class="file-row"
                  v-for="file in filter(
                    $parent.files,
                    (o) => new RegExp(`overdrachten`).test(o.path)
                  )"
                  :key="file.path"
                >
                  <span>
                    {{file.path.substring(18 + prefix.length)}}
                  </span>
                  <a
                    v-if="(
                        $parent.role > 7
                        && ($parent.status === 'Ingeleverd' || $parent.status === 'Bezig')
                      )
                      || (!$parent.redo && $parent.status === 'Bezig')
                    "
                    class="file-button"
                    @click="remove(file.path)"
                  >
                    Verwijder <awesomeIcon icon="times"/>
                  </a>
                  <a class="file-button" @click="download(file.path)">
                    Bekijken <awesomeIcon icon="eye"/>
                  </a>
                </div>
              </template>
            </div>
          </div>
        </template>

        <div v-for="(person, index) in $parent.intake.persoonsData" :key="index" class="mt20">

          <!-- Rekeninghouder gegevens -->
          <p class="subheader">
            Gegevens
            <i>
              -
              {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
              {{ person.voorletters }}
              {{ person.tussenvoegsel }}
              {{ person.achternaam }}
              ({{person.type}})
            </i>
          </p>

          <div class="row" style="padding: 20px 0 20px 20px">
            <table class="new" style="margin-top: 10px">
              <tr>
                <th width="25%">Roepnaam</th>
                <td>{{ person.roepnaam }}</td>
              </tr>
              <tr>
                <th width="25%">E-mail</th>
                <td>{{index != 0 ? person.email : $parent.email}}</td>
              </tr>
              <tr>
                <th width="25%">Tel. nummer</th>
                <td>
                    {{person.telefoonnummer}}
                    {{person.telefoonnummer2 ? `/ ${person.telefoonnummer2}` : ''}}
                </td>
              </tr>
            </table>

            <div class="sm-col-12 lg-colnm-6">
              <table class="new" style="margin-top: 10px">
                <tr>
                  <th width="25%">Straat</th>
                  <td v-if="person.zelfdeAdres == 'Yes'">
                    {{$parent.intake.persoonsData[0].straat}}
                    {{$parent.intake.persoonsData[0].huisnummer}}
                    {{$parent.intake.persoonsData[0].toevoeging}}
                  </td>
                  <td v-else>
                    {{person.straat}}
                    {{person.huisnummer}}
                    {{person.toevoeging}}
                  </td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th width="25%">Plaats</th>
                  <td>
                    {{
                      person.zelfdeAdres == 'Yes'
                        ? $parent.intake.persoonsData[0].plaats
                        : person.plaats
                    }}
                  </td>
                  <td colspan="2"></td>
                </tr>
              </table>
            </div>

            <div class="sm-col-12 lg-colnm-6">
              <table class="new" style="margin-top: 10px">
                <tr>
                  <th width="25%">Postcode</th>
                  <td>
                    {{
                      person.zelfdeAdres == 'Yes'
                        ? $parent.intake.persoonsData[0].postcode
                        : person.postcode
                    }}
                  </td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th width="25%">Land</th>
                  <td>
                    {{
                      person.zelfdeAdres == 'Yes'
                        ? $parent.intake.persoonsData[0].land
                        : person.land
                    }}
                  </td>
                  <td colspan="2"></td>
                </tr>
              </table>
            </div>
          </div>

          <!-- Paspoort of ID-kaart rekeninghouder gegevens -->
          <p class="subheader">
            {{person.identificationType}} gegevens
            <i>
              -
              {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
              {{ person.voorletters }}
              {{ person.tussenvoegsel }}
              {{ person.achternaam }}
              ({{person.type}})
            </i>
          </p>

          <div class="row" style="padding: 20px 0 10px 20px">
            <div class="sm-col-12 lg-colnm-6">
              <table class="new" style="margin-top: 10px">
                <tr>
                  <th width="25%">Voorletters</th>
                  <td>{{ person.voorletters }}</td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th width="25%">Tussenvoegsel</th>
                  <td>{{ person.tussenvoegsel }}</td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th width="25%">Geslacht</th>
                  <td>{{ person.geslacht }}</td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th width="25%">Geboorteplaats</th>
                  <td>{{ person.geboortplaats }}</td>
                  <td colspan="2"></td>
                </tr>
              </table>
            </div>

            <div class="sm-col-12 lg-colnm-6">
              <table class="new" style="margin-top: 10px">
                <tr>
                  <th width="25%">Voorna(a)m(en)</th>
                  <td>{{ person.voornaam }}</td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th width="25%">Achternaam</th>
                  <td>{{ person.achternaam }}</td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th width="25%">Geboortedatum</th>
                  <td>{{ new Date(person.geboorteDatum).toLocaleDateString() }}</td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th width="25%">Geboorteland</th>
                  <td>{{ person.geboorteland }}</td>
                  <td colspan="2"></td>
                </tr>
              </table>
            </div>
          </div>

          <div class="row" style="padding: 0 0 20px 20px">
            <table class="new">
              <tr>
                <th width="25%">
                  {{
                    person.belastingsplichtigBuitenland !== 'Yes'
                    || $parent.intake.goalData.box == '1'
                      ? 'Burgerservicenummer'
                      : 'TIN'
                  }}
                </th>
                <td>
                  {{
                    (
                      person.belastingsplichtigBuitenland !== 'Yes'
                      || $parent.intake.goalData.box == '1'
                    )
                    && person.bsn && person.bsn.length === 8
                      ? `0${person.bsn}`
                      : person.bsn
                  }}
                </td>
              </tr>
              <tr>
                <th width="25%">Documentnummer</th>
                <td>{{ person.documentnummer }}</td>
              </tr>
              <tr>
                <th width="25%">Vervaldatum</th>
                <td>{{ new Date(person.vervalDatum).toLocaleDateString() }}</td>
              </tr>
              <tr>
                <th width="25%">Belastingplichtig buitenland</th>
                <td>
                  {{
                    person.belastingsplichtigBuitenland === 'Yes'
                      ? `Ja, in ${person.belastingsplichtingLand || '?'}`
                      : 'Nee'
                  }}
                </td>
              </tr>
              <tr>
                <th width="25%">Nationaliteit</th>
                <td>{{ person.nationaliteit }}</td>
              </tr>
              <tr>
                <th width="25%">Tweede nationaliteit</th>
                <td>
                  {{
                    person.secondNationality === 'Yes'
                      ? `Ja, ${person.secondNationalityName || '?'}`
                      : 'Nee'
                  }}
                </td>
              </tr>
              <tr>
                <th width="25%">Us-person</th>
                <td>{{ person.usperson === 'Yes' ? 'Ja' : 'Nee' }}</td>
              </tr>
            </table>
          </div>

          <div class="admin-screen msg" style="padding:20px; margin: 0;">
            <span
              v-if="
                !($parent.status === 'Bezig' && $parent.writeModus)
                && $parent.status !== 'Ingeleverd'
              "
              class="msg"
            >
              Let op, de wijzigingen in deze vragenlijst kunnen niet meer worden opgeslagen
              (dit kan alleen wanneer deze status Bezig of Ingeleverd heeft).
            </span>

            <div class="flex-container flex-grow" style="margin-top: 30px">
              <customInput
                v-model="person.sterfteDatum"
                :validation="['notrequired', 'max']"
                type="date"
                :maxDatetime="new Date()"
                label="Sterftedatum"
              />
            </div>

            <div v-if="index == 0">
              <div
                v-if="
                 $parent.intake.persoonsData.slice(1)
                  && filter($parent.intake.persoonsData, (o) => !o.sterfteDatum).length
                "
                style="padding: 10px 0px 0px 20px"
                class="flex-container"
              >
                Nieuw U persoon benoemen:
              </div>
              <div class="flex-container" v-if="$parent.intake.persoonsData.slice(1)">
                <div
                  v-for="(persoon, i) in $parent.intake.persoonsData"
                  :key="i"
                >
                  <button
                    v-if="i != 0 && !persoon.sterfteDatum"
                    @click="setNewUPerson(i)"
                    style="float:right"
                  >
                    Persoon #{{i+1}}
                    {{`${
                      persoon.voorletters
                          ? `${persoon.voorletters} `
                          : ''
                      }${
                        persoon.tussenvoegsel
                          ? `${persoon.tussenvoegsel} `
                          : ''
                      }${
                        persoon.achternaam
                          ? persoon.achternaam
                          : ''
                      }`}}
                  </button>
                </div>
              </div>
              <div class="flex-container" v-else>
                Maak eerst een nieuw persoon aan.
              </div>
            </div>
            <button
              v-if="
                (
                  ($parent.status === 'Bezig' && $parent.writeModus)
                  || $parent.status === 'Ingeleverd'
                )
                && new Date(person.sterfteDatum) < new Date()
              "
              style="float: right"
              @click="saveUPerson(index)"
            >
              Opslaan
            </button>
          </div>

          <template v-if="!person.sterfteDatum || new Date(person.sterfteDatum) > new Date()">
            <!-- Identificatie document -->
            <p class="subheader">
              Identificatie
              <i>
                -
                {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                {{ person.voorletters }}
                {{ person.tussenvoegsel }}
                {{ person.achternaam }}
                ({{person.type}})
              </i>
            </p>
            <div
              class="file-row"
              v-for="file in filter(
                  $parent.files,
                  (o) => o.path.indexOf(`legitimatie${index}`) > -1
              )"
              :key="file.path"
            >
              <span>
                {{file.path.substring(18 + prefix.length)}}
              </span>
              <a class="file-button" @click="remove(file.path)">
                Verwijder <awesomeIcon icon="times"/>
              </a>
              <a class="file-button" @click="download(file.path)">
                Bekijken <awesomeIcon icon="eye"/>
              </a>
            </div>
            <cddcheck
              :cddkey="`${index}-identification`"
              :description="`Identificatie document`"
              :value="$parent.files"
              :options="[
                { value: 'Akkoord', state: 'valid' },
                { value: 'Rijbewijs geüpload', state: 'invalid' },
                { value: 'Achterkant legitimatie mist', state: 'invalid' },
                { value: 'Legitimatie ontbreekt', state: 'invalid' },
                { value: 'Slecht kopie legitimatie', state: 'invalid' },
                { value: 'Verlopen legitimatie', state: 'invalid' },
                { value: 'Echtheidskenmerken niet correct', state: 'invalid' },
              ]"
            />
            <!-- Geboorteland -->
            <cddcheck
              :cddkey="`${index}-countryofbirth`"
              :description="`Geboorteland`"
              :hasValue="true"
              :value="person.geboorteland
              "
              :options="[
                { value: 'Laag risico', state: 'valid' },
                { value: 'Gemiddeld risico', state: 'warning' },
                { value: 'Hoog risico', state: 'invalid' },
              ]"
            />
            <!-- Woonland -->
            <p class="msg">
              Let op: woonland controle vindt plaats door de Scope On Demand download knop
            </p>
            <cddcheck
              :cddkey="`${index}-residence`"
              :description="`Woonland`"
              :hasValue="true"
              :value="person.zelfdeAdres === 'Yes'
                ? $parent.intake.persoonsData[0].land
                : person.land"
              :options="[
                { value: 'Laag risico', state: 'valid' },
                { value: 'Hoog risico', state: 'warning' },
              ]"
            />

            <!-- Woonland waiver -->
            <div v-if="person.land && !eerCountries.includes(person.land)">
              <p class="subheader">
                Verklaring buiten EU
                <i>
                  -
                  {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                  {{ person.voorletters }}
                  {{ person.tussenvoegsel }}
                  {{ person.achternaam }}
                  ({{person.type}})
                </i>
              </p>
              <customInput
                v-model="modelValue[`cddfiles${index}`]"
                type="file" label="Kies een verklaring buiten EU bestand"
                :prefix="`cdd${Number(index)}-declarationoutsideeu`"
                :validation="['notrequired']"
              />
              <cddcheck
                :cddkey="`${index}-declarationoutsideeu`"
                :description="`Verklaring buiten EU (${person.land})`"
                :options="[
                  { value: 'Akkoord', state: 'valid' },
                  { value: 'Akkoord, maar...', state: 'warning' },
                  { value: 'Niet akkoord', state: 'invalid' },
                ]"
              />
            </div>

            <!-- Niet de NL nationaliteit -->
            <p
              class="subheader"
              v-if="person.dutchNationality === 'No' || person.secondNationality === 'Yes'"
            >
              Nationaliteit
              <i>
                -
                {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                {{ person.voorletters }}
                {{ person.tussenvoegsel }}
                {{ person.achternaam }}
                ({{person.type}})
              </i>
            </p>
            <cddcheck
              v-if="person.dutchNationality === 'No' || person.secondNationality === 'Yes'"
              :cddkey="`${index}-secondnationality`"
              :description="
                person.dutchNationality === 'No' && person.secondNationality === 'Yes'
                ? `Geen Ned. nationaliteit (${person.nationaliteit})
                  en een tweede nationaliteit (${person.secondNationalityName})`
                : person.secondNationality === 'Yes'
                  ? `Heeft een tweede nationaliteit (${person.secondNationalityName})`
                  : `Heeft geen nederlandse nationaliteit (${person.nationaliteit})`
              "
              :options="[
                { value: 'Akkoord', state: 'valid' },
                { value: 'Akkoord, maar...', state: 'warning' },
                { value: 'Niet akkoord', state: 'warning' },
              ]"
            />

            <!-- Bewijs van inschrijving -->
            <div
              v-if="
                (person.land && person.land != 'Nederland')
                || (person.eigenwoning == 'No' && person.huur == 'Yes')
              "
              class="mt20"
            >
              <p class="subheader">
                Bewijs van inschrijving
                <i>
                  -
                  {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                  {{ person.voorletters }}
                  {{ person.tussenvoegsel }}
                  {{ person.achternaam }}
                  ({{person.type}})
                </i>
              </p>
              <div
                class="file-row"
                v-for="file in filter(
                  $parent.files,
                  (o) => new RegExp(`inschrijvingsbewijs${index}`).test(o.path)
                )"
                :key="file.path"
              >
                <span>
                  {{file.path.substring(18 + prefix.length)}}
                </span>
                <a class="file-button" @click="remove(file.path)">
                  Verwijder <awesomeIcon icon="times"/>
                </a>
                <a class="file-button" @click="download(file.path)">
                  Bekijken <awesomeIcon icon="eye"/>
                </a>
              </div>
              <cddcheck
                :cddkey="`${index}-residentcertificate`"
                :description="`Inschrijvingsbewijs`"
                :options="[
                  { value: 'Akkoord', state: 'valid' },
                  { value: 'Akkoord, maar...', state: 'warning' },
                  { value: 'Niet akkoord', state: 'invalid' },
                ]"
              />
            </div>

            <div v-if="$parent.financeFilter(person)" class="mt20">
              <!-- Insiderregeling -->
              <p v-if="(person.insider == 'Yes' || !person.insider)" class="subheader">
                Insiderregeling
                <i>
                  -
                  {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                  {{ person.voorletters }}
                  {{ person.tussenvoegsel }}
                  {{ person.achternaam }}
                  ({{person.type}})
                </i>
              </p>
              <div
                v-if="(person.insider == 'Yes' || !person.insider)"
                class="row"
              >
                <div
                  class="file-row"
                  v-for="file in filter(
                    $parent.files,
                    (o) => new RegExp(`insider${index}`).test(o.path)
                  )"
                  :key="file.path"
                >
                  <span>
                    {{file.path.substring(18 + prefix.length)}}
                  </span>
                  <a class="file-button" @click="remove(file.path)">
                    Verwijder <awesomeIcon icon="times"/>
                  </a>
                  <a class="file-button" @click="download(file.path)">
                    Bekijken <awesomeIcon icon="eye"/>
                  </a>
                </div>
                <cddcheck
                  :cddkey="`${index}-insiderdocumentation`"
                  :description="`Insiderregeling geüpload?`"
                  :options="[
                    { value: 'Akkoord', state: 'valid' },
                    { value: 'Niet akkoord', state: 'invalid' },
                  ]"
                />
              </div>
            </div>

            <!-- Belastingplicht buitenland -->
            <div
              v-if="$parent.financeFilter(person)
                && person.belastingsplichtigBuitenland === 'Yes'
              "
            >
              <p class="subheader">
                Inkomen belastingplichtig buitenland ({{person.belastingsplichtingLand}})
                <i>
                  -
                  {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                  {{ person.voorletters }}
                  {{ person.tussenvoegsel }}
                  {{ person.achternaam }}
                  ({{person.type}})
                </i>
              </p>
              <cddcheck
                :cddkey="`${index}-taxabroad`"
                :description="`
                  Inkomsten belastingplichtig buitenland (${person.belastingsplichtingLand})
                `"
                :options="[
                { value: 'Akkoord', state: 'valid' },
                  { value: 'Akkoord, maar...', state: 'warning' },
                  { value: 'Niet akkoord', state: 'invalid' },
                ]"
              />
            </div>

            <!-- Commercieël onroerend goed -->
            <p class="subheader" v-if="person.onroerendgoed == 'Yes'">
              Commercieël vastgoed
              <i>
                -
                {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                {{ person.voornaam }}
                {{ person.tussenvoegsel }}
                {{ person.achternaam }}
                ({{person.type}})
              </i>
            </p>
            <cddcheck
              v-if="person.onroerendgoed == 'Yes'"
              :cddkey="`${index}-commercialrealestate`"
              :description="`Waarde OG is € ${
                  formatPrice(Number(person.onroerendgoedVrijeverkoopwaarde), true)
                },- ${person.onroerendgoedCommercieel === 'Yes'
                  ? `met ${person.onroerendgoedObjecten} objecten`
                  : ''
                }`"
              :options="[
                { value: 'Laag risico', state: 'valid' },
                { value: 'Hoog risico', state: 'warning' },
              ]"
            />

            <!-- Scope on demand -->
            <p class="subheader">
              Scope on demand
              <i>
                -
                {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                {{ person.voornaam }}
                {{ person.tussenvoegsel }}
                {{ person.achternaam }}
                ({{person.type}})
              </i>
            </p>
            <div v-if="!busy">
              <button
                v-if="modelValue[`cddResults${index}`] === undefined && person.geboorteDatum"
                @click="searchPerson(index)"
                style="display: block; margin-bottom: 5px;"
              >
                Zoek op voornamen:
                {{person.voornaam}} -
                {{person.achternaam}} {{person.tussenvoegsel}} -
                {{person.geboorteDatum}} -
                {{findKey(
                  $parent.allCountries,
                  o => $parent.intake.persoonsData[index].zelfdeAdres === 'Yes'
                    ? $parent.intake.persoonsData[0].land == o
                    : $parent.intake.persoonsData[index].land == o,
                )}}
              </button>
              <div
                v-else-if="modelValue[`cddResults${index}`] === undefined"
                style="padding: 5px"
              >
                Controleer of de geboortedatum is ingevuld, deze is nodig om het CDD rapport uit te
                voeren.
              </div>
              <template v-if="modelValue[`cddResults${index}`]">
                <button
                  v-for="result in modelValue[`cddResults${index}`].results"
                  :key="result.complianceId"
                  @click="downloadPerson(
                    index,
                    modelValue[`cddResults${index}`].sessionId,
                    result.complianceId,
                  )"
                  style="display: block; margin-bottom: 5px;"
                >
                  Download:
                  {{result.name}} {{result.dateOfBirth}}
                  (#{{result.complianceId}})
                  {{result.score}}%
                </button>
                <button
                  @click="downloadPerson(
                    index,
                    modelValue[`cddResults${index}`].sessionId,
                    '',
                  )"
                  style="display: block; margin-bottom: 5px;"
                >
                  Download persoon niet gevonden
                </button>
              </template>
              <p v-if="
                modelValue[`cddResults${index}`]
                && !modelValue[`cddResults${index}`].results"
              >Geen cdd resultaten gevonden.</p>
              <button
                v-if="modelValue[`cddResults${index}`] !== undefined"
                @click="deleteSearchResults(modelValue, index)"
                style="display: block"
              >
                Huidige CDD zoekresultaten verwijderen
              </button>
              <div
                class="file-row"
                v-for="file in filter(
                    $parent.files,
                    (o) => o.path.indexOf(`-cdd${index}-report`) > -1
                )"
                :key="file.path"
              >
                <span>
                  {{file.path.substring(18 + prefix.length)}}
                </span>
                <a class="file-button" @click="remove(file.path)">
                  Verwijder <awesomeIcon icon="times"/>
                </a>
                <a class="file-button" @click="download(file.path)">
                  Bekijken <awesomeIcon icon="eye"/>
                </a>
              </div>
              <cddcheck
                :cddkey="`${index}-scopeondemand`"
                :description="`Scope on demand beoordeling`"
                :options="[
                  { value: 'Akkoord', state: 'valid' },
                  { value: 'Akkoord, false hit', state: 'valid' },
                  { value: 'Akkoord, maar', state: 'warning' },
                  { value: 'Niet akkoord', state: 'invalid' },
                ]"
              />

              <!-- PEP -->
              <cddcheck
                :cddkey="`${index}-pep`"
                :description="`Politically exposed person (PEP)`"
                :options="[
                  { value: 'Nee', state: 'valid' },
                  { value: 'Ja', state: 'warning' },
                  { value: 'Gerelateerd aan', state: 'warning' },
                ]"
              />
            </div>
            <div v-else class="loader" />

            <!-- Beroep / sector -->
            <p class="subheader">
              Beroep
              <i>
                -
                {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                {{ person.voorletters }}
                {{ person.tussenvoegsel }}
                {{ person.achternaam }}
                ({{person.type}})
              </i>
            </p>
            <!-- Type inkomen -->
            <cddcheck
              v-if="$parent.financeFilter(person)"
              :cddkey="`${index}-typeofincome`"
              :description="`Type inkomen`"
              :hasValue="true"
              :value="person.inkomenType"
              :options="[
                { value: 'Laag risico', state: 'valid' },
                { value: 'Hoog risico', state: 'warning' },
              ]"
            />

            <!-- Beroep -->
            <cddcheck
              v-if="$parent.financeFilter(person)"
              :cddkey="`${index}-employmentsector`"
              :description="`Beroep`"
              :hasValue="true"
              :value="person.inkomenType === 'Anders'
                ? `Anders (${person.inkomenTypeAnders})`
                : person.beroep
              "
              :options="[
                { value: 'Laag risico', state: 'valid' },
                { value: 'Gemiddeld risico', state: 'warning' },
                { value: 'Hoog risico', state: 'warning' },
                { value: 'Niet akkoord kunnen zetten', state: 'invalid' },
              ]"
            />

            <!-- Sector -->
            <div class="msg">
              Let op, onderstaande beoordeling is in combinatie met
              arbeidssituatie ({{ person.arbeidsSituatie }}) en
              sector ({{ person.branche === 'anders' ? person.brancheAnders : person.branche }}).
            </div>
            <cddcheck
              v-if="$parent.financeFilter(person) && person.inkomenType !== 'Anders'"
              :cddkey="`${index}-sector`"
              description="Branche"
              :hasValue="true"
              :value="
                person.sector === 'geen-van-bovenstaande' || person.branche === 'anders'
                  ? `Anders (${person.sectorAnders})`
                  : $parent.selectedSector(person)
              "
              :options="[
                  { value: 'Laag risico', state: 'valid' },
                  { value: 'Gemiddeld risico', state: 'warning' },
                  { value: 'Hoog risico', state: 'warning' },
                ]"
            />
            <div
              v-if="$parent.financeFilter(person) && person.inkomenType !== 'Anders'"
              class="msg"
            >
              Valt onder de AFM sector: {{$parent.afmQualification(person)}}
            </div>

            <!-- Google search en Beroep check -->
            <div v-if="$parent.financeFilter(person)" class="mt20">
              <!-- CDD online resultaten -->
              <p class="subheader">
                G1 online resultaten (corruptie, fraude)
                <i>
                  -
                  {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                  {{ person.voornaam }}
                  {{ person.tussenvoegsel }}
                  {{ person.achternaam }}
                  ({{person.type}})
                </i>
              </p>
              <div
                class="row"
                style="background-color: #f7f8fa; padding: 5px;"
              >
                <div
                  class="flex-container flex-grow"
                  style="padding-bottom: 10px"
                >
                  <a :href="googleSearch(index, 1)" target="_blank">
                    <button style="display: block">
                      Google check 1 - volledige naam
                    </button>
                  </a>
                  <a :href="googleSearch(index, 3)" target="_blank">
                    <button style="display: block">
                      Google check 1 - roepnaam
                    </button>
                  </a>
                </div>
                <customInput
                  v-model="modelValue[`cddfiles${index}`]"
                  type="file" label="Kies een bestand"
                  :prefix="`searchresults-${index}`"
                  :validation="['files']"
                />
                <cddcheck
                  :cddkey="`${index}-cddresults`"
                  :description="`G1 online resultaten`"
                  :options="[
                    { value: 'Akkoord', state: 'valid' },
                    { value: 'Niet akkoord', state: 'invalid' },
                  ]"
                />
              </div>

              <!-- Beroep online en social media -->
              <p class="subheader">
                G2 online resultaten (werkzaamheden, LinkedIn)
                <i>
                  -
                  {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                  {{ person.voorletters }}
                  {{ person.tussenvoegsel }}
                  {{ person.achternaam }}
                  ({{person.type}})
                </i>
              </p>
              <div
                class="row"
                style="background-color: #f7f8fa; padding: 5px;"
              >
                <div
                  class="flex-container flex-grow"
                  style="padding-bottom: 10px"
                >
                  <a :href="googleSearch(index, 2)" target="_blank">
                    <button style="display: block">
                      Google check 2 - volledige naam
                    </button>
                  </a>
                  <a :href="googleSearch(index, 4)" target="_blank">
                    <button style="display: block">
                      Google check 2 - roepnaam
                    </button>
                  </a>
                </div>
                <customInput
                  v-model="modelValue[`cddfiles${index}`]"
                  type="file" label="Kies een bestand"
                  :prefix="`socialmediaprofile-${index}`"
                  :validation="['files']"
                />
                <cddcheck
                  :cddkey="`${index}-socialmediaprofile`"
                  :description="`G2 online resultaten`"
                  :options="[
                    { value: 'Komt overeen', state: 'valid'  },
                    { value: 'Geen profiel gevonden', state: 'valid' },
                    { value: 'Komt niet overeen', state: 'warning' },
                  ]"
                />
              </div>
            </div>

            <div class="mt20">
              <template
                v-if="
                  $parent.intake.rekeningData.type !== 'Bedrijfsrekening'
                  && modelValue.beleggen.brand !== 'VMVB'
                  && modelValue.beleggen.brand !== 'BVS'
                "
              >
                <h2 class="title">
                  Extra controle
                </h2>
                <p class="msg" v-if="preCheck(person, index) === 'unfinished'">
                  Vul eerst alle CDD velden hierboven in.
                </p>
                <p class="msg" v-else-if="preCheck(person, index) === 'positive'">
                  Geen extra controle nodig.
                </p>
                <p class="msg" v-else>
                  Let op, er is een extra controle nodig.
                </p>
              </template>
              <template
                v-if="
                  $parent.intake.rekeningData.type === 'Bedrijfsrekening'
                  || modelValue.beleggen.brand === 'VMVB'
                  || modelValue.beleggen.brand === 'BVS'
                  || preCheck(person, index) === 'negative'
                "
              >
                <!-- Herkomst vermogen -->
                <p class="subheader">
                  {{
                    $parent.intake.rekeningData.type !== 'Bedrijfsrekening'
                    && modelValue.beleggen.brand !== 'VMVB'
                    && modelValue.beleggen.brand !== 'BVS'
                      ? '(extra)'
                      : ''
                  }}
                    herkomst vermogen
                  <i>
                    -
                    {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                    {{ person.voorletters }}
                    {{ person.tussenvoegsel }}
                    {{ person.achternaam }}
                    ({{person.type}})
                  </i>
                </p>
                <template v-if="$parent.financeFilter(person)">
                  <cddcheck
                    v-if="$parent.intake.goalData.box === '1'"
                    :cddkey="`${index}-wealthorigin`"
                    description="Herkomst vermogen (box 1)"
                    :options="[
                      { value: 'Laag risico', state: 'valid'},
                      { value: 'Gemiddeld risico', state: 'warning' },
                      { value: 'Hoog risico', state: 'warning' },
                    ]"
                  />
                  <template v-else>
                    <cddcheck
                      v-if="person.herkomstVermogenSalaris === 'Yes'"
                      :cddkey="`${index}-wealthoriginsalary`"
                      description="Herkomst vermogen (sparen / beleggen uit salaris)"
                      :options="[
                        { value: 'Laag risico', state: 'valid'},
                        { value: 'Gemiddeld risico', state: 'warning' },
                        { value: 'Hoog risico', state: 'warning' },
                      ]"
                    />
                    <cddcheck
                      v-if="person.herkomstVermogenErfenis === 'Yes'"
                      :cddkey="`${index}-wealthoriginheritage`"
                      description="Herkomst vermogen (erfenis)"
                      :options="[
                        { value: 'Laag risico', state: 'valid'},
                        { value: 'Gemiddeld risico', state: 'warning' },
                        { value: 'Hoog risico', state: 'warning' },
                      ]"
                    />
                    <cddcheck
                      v-if="person.herkomstVermogenSchenking === 'Yes'"
                      :cddkey="`${index}-wealthorigindonation`"
                      description="Herkomst vermogen (schenking)"
                      :options="[
                        { value: 'Laag risico', state: 'valid'},
                        { value: 'Gemiddeld risico', state: 'warning' },
                        { value: 'Hoog risico', state: 'warning' },
                      ]"
                    />
                    <cddcheck
                      v-if="person.herkomstVermogenWoningverkoop === 'Yes'"
                      :cddkey="`${index}-wealthoriginhousesales`"
                      :description="`Herkomst vermogen (woningverkoop:
                        ${person.woningVerkoopPostcode},
                        ${person.woningVerkoopHuisnummer}${person.woningVerkoopToevoeging})`
                      "
                      :options="[
                        { value: 'Laag risico', state: 'valid'},
                        { value: 'Gemiddeld risico', state: 'warning' },
                        { value: 'Hoog risico', state: 'warning' },
                      ]"
                    />
                    <cddcheck
                      v-if="person.herkomstVermogenBedrijfsverkoop === 'Yes'"
                      :cddkey="`${index}-wealthorigincompanysales`"
                      description="Herkomst vermogen (bedrijfsverkoop)"
                      :options="[
                        { value: 'Laag risico', state: 'valid'},
                        { value: 'Gemiddeld risico', state: 'warning' },
                        { value: 'Hoog risico', state: 'warning' },
                      ]"
                    />
                    <cddcheck
                      v-if="person.herkomstVermogenBox1lijfrente === 'Yes'"
                      :cddkey="`${index}-wealthoriginbox1annuity`"
                      description="Herkomst vermogen (box 1-lijfrente)"
                      :options="[
                        { value: 'Laag risico', state: 'valid'},
                        { value: 'Gemiddeld risico', state: 'warning' },
                        { value: 'Hoog risico', state: 'warning' },
                      ]"
                    />
                    <cddcheck
                      v-if="person.herkomstVermogenBox3lijfrente === 'Yes'"
                      :cddkey="`${index}-wealthoriginbox3annuity`"
                      description="Herkomst vermogen (box 3-polis)"
                      :options="[
                        { value: 'Laag risico', state: 'valid'},
                        { value: 'Gemiddeld risico', state: 'warning' },
                        { value: 'Hoog risico', state: 'warning' },
                      ]"
                    />
                    <cddcheck
                      v-if="person.herkomstVermogenGoudenhanddruk === 'Yes'"
                      :cddkey="`${index}-wealthorigingoldenhandshake`"
                      description="Herkomst vermogen (Gouden handdruk)"
                      :options="[
                        { value: 'Laag risico', state: 'valid'},
                        { value: 'Gemiddeld risico', state: 'warning' },
                        { value: 'Hoog risico', state: 'warning' },
                      ]"
                    />
                    <cddcheck
                      v-if="person.herkomstVermogenCryptovaluta === 'Yes'"
                      :cddkey="`${index}-wealthorigincrypto`"
                      description="Herkomst vermogen (cryptovaluta)"
                      :options="[
                        { value: 'Laag risico', state: 'valid'},
                        { value: 'Gemiddeld risico', state: 'warning' },
                        { value: 'Hoog risico', state: 'warning' },
                      ]"
                    />
                    <cddcheck
                      v-if="person.herkomstVermogenAnders === 'Yes'"
                      :cddkey="`${index}-wealthorigindifferent`"
                      :description="
                        `Herkomst vermogen (Anders: ${person.herkomstVermogenOmschrijving})`
                      "
                      :options="[
                        { value: 'Laag risico', state: 'valid'},
                        { value: 'Gemiddeld risico', state: 'warning' },
                        { value: 'Hoog risico', state: 'warning' },
                      ]"
                    />
                  </template>
                </template>

              <!-- Kadaster informatie-->
              <div v-if="$parent.financeFilter(person)" class="mt20">
                <p class="subheader">
                  {{
                    $parent.intake.rekeningData.type !== 'Bedrijfsrekening'
                    && modelValue.beleggen.brand !== 'VMVB'
                    && modelValue.beleggen.brand !== 'BVS'
                      ? '(extra)'
                      : ''
                  }}
                  kadaster informatie
                  <i>
                    -
                    {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                    {{ person.voorletters }}
                    {{ person.tussenvoegsel }}
                    {{ person.achternaam }}
                    ({{person.type}}),
                    {{ person.geboorteDatum}}
                    <br />
                    <template v-if="person.zelfdeAdres === 'Yes'">
                      {{ $parent.intake.persoonsData[0].straat }}
                      {{ $parent.intake.persoonsData[0].huisnummer }}
                      {{ $parent.intake.persoonsData[0].toevoeging || '' }}
                      {{ $parent.intake.persoonsData[0].postcode }}
                      {{ $parent.intake.persoonsData[0].plaats }}
                      {{ $parent.intake.persoonsData[0].land }}
                    </template>
                    <template v-else>
                      {{ person.straat }}
                      {{ person.huisnummer }}
                      {{ person.toevoeging || '' }}
                      {{ person.postcode }}
                      {{ person.plaats }}
                      {{ person.land }}
                    </template>
                  </i>
                </p>
                <customInput
                  v-model="modelValue[`cddfiles${index}`]"
                  type="file" label="Kies een kadaster bestand"
                  :prefix="`cdd${Number(index)}-landregistry`"
                  :validation="['notrequired']"
                />
                <cddcheck
                  :cddkey="`${index}-landregistry`"
                  description="Kadaster informatie"
                  :options="[
                    { value: 'Akkoord', state: 'valid' },
                    { value: 'Akkoord, maar...', state: 'warning' },
                    { value: 'Niet akkoord', state: 'invalid' },
                  ]"
                />
              </div>

              <!-- Overig onroerend goed kadaster informatie -->
              <cddcheck
                v-if="person.onroerendgoed == 'Yes'"
                :cddkey="`${index}-realestate`"
                description="Overig onroerend goed kadaster informatie"
                :options="[
                  { value: 'Akkoord', state: 'valid' },
                  { value: 'Akkoord, maar...', state: 'warning' },
                  { value: 'Niet gevonden', state: 'invalid' },
                ]"
              />

              <!-- Company check -->
              <p class="subheader">
                {{
                  $parent.intake.rekeningData.type !== 'Bedrijfsrekening'
                  && modelValue.beleggen.brand !== 'VMVB'
                  && modelValue.beleggen.brand !== 'BVS'
                    ? '(extra)'
                    : ''
                }}
                company check
                <i>
                  -
                  {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                  {{ person.voorletters }}
                  {{ person.tussenvoegsel }}
                  {{ person.achternaam }}
                  ({{person.type}})
                </i>
              </p>

              <div v-if="$parent.financeFilter(person)">
                <!-- company check -->
                <customInput
                  v-model="modelValue[`cddfiles${index}`]"
                  type="file" label="Kies een bedrijfsbestand"
                  :prefix="`cdd${Number(index)}-companycheck`"
                  :validation="['notrequired']"
                />
                <cddcheck
                  :cddkey="`${index}-companycheck`"
                  description="Company check informatie"
                  :options="[
                    { value: 'Akkoord', state: 'valid' },
                    { value: 'Niet gevonden', state: 'valid' },
                    { value: 'meer informatie nodig', state: 'warning' },
                    { value: 'Niet akkoord', state: 'invalid' },
                  ]"
                />
                <!-- UBO check -->
                <cddcheck
                  v-if="
                    person.inkomenType !== 'Eenmanszaak'
                    && $parent.intakeAdmin.cdd[`${index}-companycheck`]
                    && $parent.intakeAdmin.cdd[`${index}-companycheck`].answer
                    && $parent.intakeAdmin.cdd[`${index}-companycheck`].answer !== 'Niet gevonden'
                  "
                  :cddkey="`${index}-ubocheck`"
                  description="UBO check"
                  :options="[
                    { value: 'Akkoord', state: 'valid' },
                    { value: 'Akkoord, maar...', state: 'warning' },
                    { value: 'Niet akkoord', state: 'invalid' },
                  ]"
                />
              </div>

              <!-- BV statuen -->
              <div
                v-if="
                  $parent.financeFilter(person)
                  && $parent.intake.rekeningData.type === 'Bedrijfsrekening'
                "
              >
                <div
                  class="file-row"
                  v-for="file in filter(
                    $parent.files,
                    (o) => o.path.includes('statuten')
                  )"
                  :key="file.path"
                >
                  <span>
                    {{file.path.substring(18 + prefix.length)}}
                  </span>
                  <a class="file-button" @click="remove(file.path)">
                    Verwijder <awesomeIcon icon="times"/>
                  </a>
                  <a class="file-button" @click="download(file.path)">
                    Bekijken <awesomeIcon icon="eye"/>
                  </a>
                </div>
                <cddcheck
                  :cddkey="`${index}-companystatutes`"
                  description="Doelstelling statuten bedrijf?"
                  :options="[
                    { value: 'Akkoord', state: 'valid' },
                    { value: 'Akkoord, maar...', state: 'warning' },
                    { value: 'Niet akkoord', state: 'invalid' },
                  ]"
                />
              </div>

              <!-- BV jaarrekening -->
              <div
                v-if="
                  $parent.financeFilter(person)
                  && person.inkomenType === 'Pensioen'
                  && person.persioenBeheer === 'Yes'
                "
              >
                <div
                  class="file-row"
                  v-for="file in filter(
                    $parent.files,
                    (o) => new RegExp(`pensioenbv${index}`).test(o.path)
                  )"
                  :key="file.path"
                >
                  <span>
                    {{file.path.substring(18 + prefix.length)}}
                  </span>
                  <a class="file-button" @click="remove(file.path)">
                    Verwijder <awesomeIcon icon="times"/>
                  </a>
                  <a class="file-button" @click="download(file.path)">
                    Bekijken <awesomeIcon icon="eye"/>
                  </a>
                </div>
                <cddcheck
                  :cddkey="`${index}-companyfinancialstatements`"
                  description="Pensioen BV jaarrekening geüpload?"
                  :options="[
                    { value: 'Akkoord', state: 'valid' },
                    { value: 'Akkoord, maar...', state: 'warning' },
                    { value: 'Niet akkoord', state: 'invalid' },
                  ]"
                />
              </div>

              <!-- Bedrijf -->
              <cddcheck
                v-if="$parent.financeFilter(person) && person.inkomenType !== 'Anders'"
                :cddkey="`${index}-tradedcompany`"
                description="Bedrijf"
                :hasValue="true"
                :value="person.bedrijf"
                :options="[
                  { value: 'Geen effecten uitgevende instelling', state: 'valid' },
                  { value: 'Effecten uitgevende instelling', state: 'warning' },
                ]"
              />

              <!-- Kamer van koophandel registratie -->
              <cddcheck
                v-if="person.inkomenType == 'Zelfstandige' || person.inkomenType == 'Eenmanszaak'"
                :cddkey="`${index}-companyregistration`"
                :hasValue="true"
                :value="person.inkomenType"
                description="Kamer van Koophandel registratie"
                :options="[
                  { value: 'Akkoord', state: 'valid' },
                  { value: 'Akkoord, maar...', state: 'warning' },
                  { value: 'Niet akkoord', state: 'invalid' },
                ]"
              />
              </template>
          </div>

            <!-- Algemeen uploadveld -->
            <p class="subheader">
              Algemeen uploadveld
              <i>
                -
                {{ person.geslacht == 'man' ? 'Heer' : 'Mevrouw' }}
                {{ person.voorletters }}
                {{ person.tussenvoegsel }}
                {{ person.achternaam }}
                ({{person.type}})
              </i>
            </p>
            <customInput
              v-model="modelValue[`cddfiles${index}`]"
              type="file"
              :prefix="`${index}-generalfiles`"
              :validation="['notrequired']"
            />
          </template>
        </div>

        <!-- Transactie monitor -->
        <div class="row">
          <p class="subheader">Transactie monitor</p>
          <customInput
            v-model="modelValue.transactionMonitorAmount"
            type="money"
            placeholder="Dit bedrag wordt automatisch ingevuld"
            label="Transactie monitor bedrag"
            :validation="['notrequired']"
          />
        </div>

        <!-- totale risico beoordeling -->
        <div
          style="margin-top: 10px"
          class="card"
          v-if="($parent.intakeAdmin.cddStatus.handedText === 'CDD ingediend'
            || $parent.intakeAdmin.cddStatus.text === 'CDD afgerond')
          "
        >
          <p class="subheader" style="margin-top: 10px">
            Totale risico beoordeling
            <span v-if="$parent.port" style="float: right">
              Port. nummer: {{$parent.port}}
            </span>
          </p>
          <p v-if="totaalIndienenErrors.length > 0" class="msg" style="margin: 0">
            Let op, de totale risico beoordeling kan pas uitgevoerd worden als alle CDD velden
            ingevuld zijn en als de behandelaar en risico bepaler verschillend zijn.
          </p>
          <cddcheck
            :disabled="totaalIndienenErrors.length > 0
              || (
                $parent.intakeAdmin.cddStatus.handedUser
                && (
                  $parent.intakeAdmin.cddStatus.handedUser === $store.state.name
                  && $parent.intakeAdmin.cddStatus.handedText === 'CDD ingediend'
                )
              )
              || $parent.intakeAdmin.cddStatus.text === 'CDD afgerond'
            "
            :cddkey="`${0}-riskassesment`"
            description="Totale risico beoordeling"
            @changed="setTransactionMonitor()"
            :options="[
              { value: 'Laag risico', state: 'valid' },
              { value: 'Gemiddeld risico', state: 'warning' },
              { value: 'Hoog risico', state: 'warning' },
              { value: 'Afgewezen', state: 'invalid' },
            ]"
          />
        </div>

        <div class="cddDiv">
          <p
            class="msg"
            v-if="
              $parent.intakeAdmin.cddStatus.handedText === 'CDD ingediend'
              && $parent.intakeAdmin.cddStatus.text !== 'CDD afgerond'
            "
          >
            Let op, Om het 4 ogen principe te borgen bij het afwikkelen van de CDD controle, is
            het splitsen van een behandelaar en risico bepaler verplicht.
          </p>
          <button
            v-if="
              $parent.intakeAdmin.cddStatus.handedText !== 'CDD ingediend'
              && $parent.intakeAdmin.cddStatus.text !== 'CDD afgerond'
            "
            @click="
              totaalIndienenErrors.length + errors === 0
                ? setCdd()
                : $store.state.intakeValidate = true
            "
            :class="[totaalIndienenErrors.length + errors === 0 ? '' : 'disabled']"
          >
            CDD indienen <awesomeIcon icon="binoculars" />
          </button>
          <button
            v-if="
              $parent.intakeAdmin.cddStatus.handedText === 'CDD ingediend'
              && $parent.intakeAdmin.cddStatus.text !== 'CDD afgerond'
            "
            :class="[$parent.intakeAdmin.cddStatus.handedUser !== $store.state.name
              && totaalErrors.length + errors === 0
              ? ''
              : 'disabled']
            "
            @click="
            $parent.intakeAdmin.cddStatus.handedUser !== $store.state.name
              && totaalErrors.length + errors === 0
              ? setStatus()
              : $store.state.intakeValidate = true
            "
          >
            CDD afronden <awesomeIcon icon="check" />
          </button>
          <button
            v-if="$parent.intakeAdmin.cddStatus.text === 'CDD afgerond'"
            @click="resetCdd()"
          >
            reset CDD
          </button>
          <span v-if="$parent.intakeAdmin.cddStatus.handedText === 'CDD ingediend'">
            CDD ingediend op
            <b>{{new Date($parent.intakeAdmin.cddStatus.handedDate).toLocaleString()}}</b>
            door <b>{{$parent.intakeAdmin.cddStatus.handedUser}}</b>
          </span><br />
          <span v-if="$parent.intakeAdmin.cddStatus.text === 'CDD afgerond'">
            CDD afgerond op
            <b>{{new Date($parent.intakeAdmin.cddStatus.date).toLocaleString()}}</b>
            door <b>{{$parent.intakeAdmin.cddStatus.user}}</b>
          </span>
          <span v-if="$parent.intakeAdmin.cddStatus.resetText === 'CDD gereset'">
            CDD gereset op
            <b>{{new Date($parent.intakeAdmin.cddStatus.resetDate).toLocaleString()}}</b>
            door <b>{{$parent.intakeAdmin.cddStatus.resetUser}}</b>
          </span>
        </div>
      </div>

      <div class="card">
        <div class="header">
          <awesomeIcon icon="file" /> Gekoppelde bestanden
          <span
            @click="showFiles = !showFiles"
            style="float: right; cursor: pointer;"
            class="no-padding"
          >
            {{showFiles ? 'Sluit' : 'Bekijk'}} bestanden
            <awesomeIcon :icon="showFiles ? 'eye-slash' : 'eye'" />
          </span>
        </div>
        <div class="content inset" v-if="showFiles">
          <table class="new interactive" v-if="$parent.files">
            <tr v-for="file in $parent.files" :key="file.path">
              <td @click="download(file.path)">{{ file.path }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  filter, sumBy, find, remove, clone, map, join, findKey, sortBy,
} from 'lodash-es';
import changeuser from './changeUser';
import cddcheck from '../ui/cddChecker';
import pskForm from './pskForm';

export default {
  name: 'IntakeAdminSettings',
  emits: ['update:model-value'],
  components: {
    changeuser,
    cddcheck,
    pskForm,
  },
  data() {
    return {
      focusedError: null,
      showOldLogs: false,
      showErrors: false,
      showFiles: false,
      showPskFiles: false,
      prefix: 'psk',
      selectedPsk: {},
      pskFormToggle: false,
      changePersonModal: false,
      location: window.location,
      transactions: [],
      intakeLogs: [],
      busy: false,
      noteToggle: false,
      openMessage: false,
      messageTitle: 'Afhandeling rekening',
      messageBody: `
        Beste heer/mevrouw,<br><br>
        Voor de afhandeling van de rekening hebben wij extra informatie of uw hulp nodig.
        De door ons gevraagde actie kunt u vinden op de overzicht pagina van de vragenlijst.
        Klik op onderstaande knop om de vragenlijst te openen.<br><br>
        <a href="?intake=${this.$parent.id}" target="_blank" class="button">Ga naar de vragenlijst</a><br><br>
        Met vriendelijke groet,<br><br>
        ${this.modelValue.beleggen.brand}
      `,
      eerCountries: [
        'België',
        'Bulgarije',
        'Cyprus',
        'Denemarken',
        'Duitsland',
        'Estland',
        'Finland',
        'Frankrijk',
        'Griekenland',
        'Hongarije',
        'Ierland',
        'IJsland',
        'Italië',
        'Kroatië',
        'Letland',
        'Liechtenstein',
        'Litouwen',
        'Luxemburg',
        'Malta',
        'Nederland',
        'Noorwegen',
        'Oostenrijk',
        'Polen',
        'Portugal',
        'Roemenië',
        'Slovenië',
        'Slowakije',
        'Spanje',
        'Tsjechië',
        'Zweden',
      ],
    };
  },
  props: {
    modelValue: Object,
  },
  computed: {
    activeOffers() {
      if (filter(
        this.$parent.intake.offers,
        (o) => !o.deleted
        && this.$parent.intakeAdmin.offers[o.offerId]
        && this.$parent.intakeAdmin.offers[o.offerId].calculated,
      ).length > 0
      || filter(
        this.$parent.intake.offers,
        (o) => !o.deleted
        && o.selected
        && this.$parent.intakeAdmin.offers[o.offerId],
      ).length > 0) {
        return true;
      }
      return false;
    },
    totaalIndienenErrors() {
      const errorArray = [];
      const tempArray = Object.entries(this.$store.state.cdderrors);
      for (let i = 0; i < tempArray.length; i += 1) {
        const [description, cddkey, state, reason] = tempArray[i][1].split(';');
        if (
          state !== 'valid'
          && !(state === 'warning' && Number(reason))
          && description !== 'Totale risico beoordeling'
        ) {
          errorArray.push({
            uid: tempArray[i][0],
            description,
            cddkey,
            state,
            reason,
          });
        }
      }
      return errorArray;
    },
    totaalErrors() {
      const errorArray = [];
      const tempArray = Object.entries(this.$store.state.cdderrors);
      for (let i = 0; i < tempArray.length; i += 1) {
        const [description, cddkey, state, reason] = tempArray[i][1].split(';');
        if (
          state !== 'valid'
          && !(state === 'warning' && Number(reason))
        ) {
          errorArray.push({
            uid: tempArray[i][0],
            description,
            cddkey,
            state,
            reason,
          });
        }
      }
      return errorArray;
    },
    parsedCddErrors() {
      const errorArray = [];
      const tempArray = Object.entries(this.$store.state.cdderrors);
      for (let i = 0; i < tempArray.length; i += 1) {
        const [description, cddkey, state, reason] = tempArray[i][1].split(';');
        let userIndex = null;
        const userIndexSubstring = cddkey.split('-')[0];
        if (!Number.isNaN(Number(userIndexSubstring))) {
          userIndex = Number(userIndexSubstring);
        }
        if (state !== 'valid' && !(state === 'warning' && Number(reason))) {
          errorArray.push({
            uid: tempArray[i][0],
            userIndex,
            description,
            cddkey,
            state,
            reason,
          });
        }
      }
      return errorArray;
    },
    errors() {
      return filter(this.$store.state.intake, (object, key) => (key[0] === '#' ? false : !object)).length;
    },
    value() {
      return this.modelValue;
    },
    labels() {
      const labels = this.$parent.accountLabels.slice(0);
      labels.push({ label: 'Geen', value: undefined });
      return labels;
    },
    labelsAtp() {
      const labels = this.$parent.accountLabelsAtp.slice(0);
      labels.push({ label: 'Geen', value: undefined });
      return labels;
    },
  },
  created() {
    this.sdk.getIntakeTransactions(this.$parent.getQueryVariable('intake'), (response) => {
      if (response.status === 200) {
        this.transactions = response.data;
      }
    });
    this.getIntakeLogs();
  },
  methods: {
    find,
    filter,
    sumBy,
    map,
    join,
    findKey,
    getIntakeLogs() {
      this.sdk.getIntakeLogs(this.$parent.getQueryVariable('intake'), (response) => {
        if (response.status === 200) {
          this.intakeLogs = sortBy(response.data, 'date');
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
    saveUPerson(personIndex) {
      if (
        personIndex === 0
        && this.$parent.intake.persoonsData[personIndex].sterfteDatum
        && filter(this.$parent.intake.persoonsData, (o) => !o.sterfteDatum).length > 0) {
        this.changePersonModal = true;
        return;
      }
      this.$parent.storeIntake(this.$parent.intake.step);
    },
    setNewUPerson(fromUser) {
      this.$parent.storeIntake(this.$parent.intake.step, null, false, false, () => {
        this.sdk.newUPerson(
          this.getQueryVariable('intake'),
          fromUser,
          0,
          (response) => {
            if (response.status === 200) {
              window.onbeforeunload = () => {};
              window.location.href = `?intake=${this.getQueryVariable('intake')}`;
            } else if (response.status === 404 || response.status === 403) {
              this.$store.state.confirm.toggle({
                alert: true,
                text: response.data.message,
                cb: () => {},
              });
            }
          },
        );
      });
    },
    setManagerName() {
      const obj = find(this.labels, {
        value: this.modelValue.beleggen.manager,
      });
      if (obj) {
        Object.assign(
          this.modelValue.beleggen,
          { managerName: obj.label.split('[')[0].trim() },
        );
        this.$parent.storeAdmin();
      }
    },
    setSalesName() {
      const obj = find(this.labelsAtp, {
        value: this.modelValue.beleggen.sales,
      });
      if (obj) {
        Object.assign(
          this.modelValue.beleggen,
          { salesName: obj.label.split('[')[0].trim() },
        );
        this.$parent.storeAdmin();
      }
    },
    preCheck(user, index) {
      if (this.$parent.financeFilter(user)) {
        // check commercialrealestate
        if (user.onroerendgoed === 'Yes') {
          if (
            !this.$store.state.cdd[`${index}-commercialrealestate`]
            || this.$store.state.cdd[`${index}-commercialrealestate`].state === 'none'
          ) {
            return 'unfinished';
          }
          if (this.$store.state.cdd[`${index}-commercialrealestate`].state !== 'valid') {
            return 'negative';
          }
        }
        // sector
        if (user.inkomenType !== 'Anders') {
          if (
            !this.$store.state.cdd[`${index}-sector`]
            || this.$store.state.cdd[`${index}-sector`].state === 'none'
          ) {
            return 'unfinished';
          }
          if (this.$store.state.cdd[`${index}-sector`].state !== 'valid') {
            return 'negative';
          }
        }
        // cdd results
        if (
          !this.$store.state.cdd[`${index}-cddresults`]
          || this.$store.state.cdd[`${index}-cddresults`].state === 'none'
        ) {
          return 'unfinished';
        }
        if (this.$store.state.cdd[`${index}-cddresults`].state !== 'valid') {
          return 'negative';
        }
        // social media
        if (
          !this.$store.state.cdd[`${index}-socialmediaprofile`]
          || this.$store.state.cdd[`${index}-socialmediaprofile`].state === 'none'
        ) {
          return 'unfinished';
        }
        if (this.$store.state.cdd[`${index}-socialmediaprofile`].state !== 'valid') {
          return 'negative';
        }
      }
      // scope on demand
      if (
        !this.$store.state.cdd[`${index}-scopeondemand`]
        || this.$store.state.cdd[`${index}-scopeondemand`].state === 'none'
      ) {
        return 'unfinished';
      }
      if (this.$store.state.cdd[`${index}-scopeondemand`].state !== 'valid') {
        return 'negative';
      }
      // pep
      if (
        !this.$store.state.cdd[`${index}-pep`]
        || this.$store.state.cdd[`${index}-pep`].state === 'none'
      ) {
        return 'unfinished';
      }
      if (this.$store.state.cdd[`${index}-pep`].state !== 'valid') {
        return 'negative';
      }
      return 'positive';
    },
    loadPsk(overdracht) {
      this.selectedPsk = overdracht;
      this.pskFormToggle = true;
    },
    pushToCRM() {
      this.sdk.pushIntakeCRM(
        this.$parent.getQueryVariable('intake'),
        (response) => {
          // eslint-disable-next-line
          alert(response.data.message);
        },
      );
    },
    sendWelcome() {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u de welkoms offertevoortstel-mail opnieuw wilt versturen?',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.adminIntakeWelcome(
              this.$parent.getQueryVariable('intake'),
              (response) => {
                // eslint-disable-next-line
                alert(response.data.message);
              },
            );
          }
        },
      });
    },
    changeFee() {
      Object.assign(
        this.modelValue.beleggen,
        filter(this.$parent.feeList, {
          feeName: this.modelValue.beleggen.feeName,
        })[0],
      );
      this.$parent.storeAdmin();
    },
    resetCdd() {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u de totale risico beoordeling, het indienen en het afronden wilt resetten?',
        confirmText: 'Resetten',
        cb: (confirmed) => {
          if (confirmed) {
            this.$parent.intakeAdmin.cddStatus = {
              handedText: '',
              text: '',
              resetText: 'CDD gereset',
              resetDate: new Date(),
              resetUser: this.$store.state.name,
            };
            this.$store.state.cdd['0-riskassesment'] = {
              state: 'none',
            };
            this.$parent.storeAdmin();
          }
        },
      });
    },
    sendMessage() {
      this.sdk.createMessage(
        `${this.$parent.client}`,
        this.messageTitle,
        this.messageBody,
        0,
        0,
        () => {},
        this.modelValue.beleggen.brand,
      );
      this.openMessage = false;
    },
    googleSearch(personIndex, type) {
      if (type === 1) {
        if (!this.$parent.intake.persoonsData[personIndex].tussenvoegsel) {
          return `https://www.google.nl/search?hl=&site&q=%22${this.$parent.intake.persoonsData[personIndex].voornaam} ${this.$parent.intake.persoonsData[personIndex].achternaam}%22+AND+%22corrupt%E2%80%9D+OR+%E2%80%9Ccorruptie%E2%80%9D+OR+%E2%80%9Cfraude%E2%80%9D+OR+%E2%80%9Comkoping%E2%80%9D+OR+%E2%80%9Comgekocht%E2%80%9D+OR+%E2%80%9Csmeergeld%E2%80%9D+OR+%E2%80%9Csanctie%E2%80%9D+OR+%E2%80%9Csancties%E2%80%9D+OR+%E2%80%9Caangeklaagd%E2%80%9D+OR+%E2%80%9Cwitwassen%E2%80%9D+OR+%E2%80%9Cbeschuldigd%E2%80%9D+OR+%E2%80%9Cvervolgd%E2%80%9D+OR+%E2%80%9Cbeslaglegging%E2%80%9D+OR+%E2%80%9Cdrugs%E2%80%9D+OR+%E2%80%9Cveroordeeld%E2%80%9D+OR+%E2%80%9Caangehouden%E2%80%9D+OR+%E2%80%9Carrestatie%E2%80%9D+OR+%E2%80%9Conderzoek%E2%80%9D+OR+%E2%80%9COpenbaar+Ministerie%E2%80%9D+OR+%E2%80%9Ctoezichthouder%E2%80%9D+OR+%E2%80%9Cmisdaad%E2%80%9D+OR+%E2%80%9Cterrorisme%E2%80%9D+OR+%E2%80%9Cverduistering%E2%80%9D+OR+%E2%80%9Crechtszaak%E2%80%9D+OR+%E2%80%9Csmokkel%E2%80%9D+OR+%E2%80%9Cschikking%E2%80%9D`;
        }
        return `https://www.google.nl/search?hl=&site&q=%22${this.$parent.intake.persoonsData[personIndex].voornaam} ${this.$parent.intake.persoonsData[personIndex].tussenvoegsel} ${this.$parent.intake.persoonsData[personIndex].achternaam}%22+AND+%22corrupt%E2%80%9D+OR+%E2%80%9Ccorruptie%E2%80%9D+OR+%E2%80%9Cfraude%E2%80%9D+OR+%E2%80%9Comkoping%E2%80%9D+OR+%E2%80%9Comgekocht%E2%80%9D+OR+%E2%80%9Csmeergeld%E2%80%9D+OR+%E2%80%9Csanctie%E2%80%9D+OR+%E2%80%9Csancties%E2%80%9D+OR+%E2%80%9Caangeklaagd%E2%80%9D+OR+%E2%80%9Cwitwassen%E2%80%9D+OR+%E2%80%9Cbeschuldigd%E2%80%9D+OR+%E2%80%9Cvervolgd%E2%80%9D+OR+%E2%80%9Cbeslaglegging%E2%80%9D+OR+%E2%80%9Cdrugs%E2%80%9D+OR+%E2%80%9Cveroordeeld%E2%80%9D+OR+%E2%80%9Caangehouden%E2%80%9D+OR+%E2%80%9Carrestatie%E2%80%9D+OR+%E2%80%9Conderzoek%E2%80%9D+OR+%E2%80%9COpenbaar+Ministerie%E2%80%9D+OR+%E2%80%9Ctoezichthouder%E2%80%9D+OR+%E2%80%9Cmisdaad%E2%80%9D+OR+%E2%80%9Cterrorisme%E2%80%9D+OR+%E2%80%9Cverduistering%E2%80%9D+OR+%E2%80%9Crechtszaak%E2%80%9D+OR+%E2%80%9Csmokkel%E2%80%9D+OR+%E2%80%9Cschikking%E2%80%9D`;
      } if (type === 2) {
        if (!this.$parent.intake.persoonsData[personIndex].tussenvoegsel) {
          return `https://www.google.nl/search?hl=&site=&q=%22${this.$parent.intake.persoonsData[personIndex].voornaam} ${this.$parent.intake.persoonsData[personIndex].achternaam}%22+AND+%22werkzaamheden%E2%80%9D+OR+%E2%80%9CBeroep%E2%80%9D+OR+%E2%80%9Cwerk%E2%80%9D+OR+%E2%80%9Clinkedin%E2%80%9D`;
        }
        return `https://www.google.nl/search?hl=&site=&q=%22${this.$parent.intake.persoonsData[personIndex].voornaam} ${this.$parent.intake.persoonsData[personIndex].tussenvoegsel} ${this.$parent.intake.persoonsData[personIndex].achternaam}%22+AND+%22werkzaamheden%E2%80%9D+OR+%E2%80%9CBeroep%E2%80%9D+OR+%E2%80%9Cwerk%E2%80%9D+OR+%E2%80%9Clinkedin%E2%80%9D`;
      } if (type === 3) {
        if (!this.$parent.intake.persoonsData[personIndex].tussenvoegsel) {
          return `https://www.google.nl/search?hl=&site&q=%22${this.$parent.intake.persoonsData[personIndex].roepnaam} ${this.$parent.intake.persoonsData[personIndex].achternaam}%22+AND+%22corrupt%E2%80%9D+OR+%E2%80%9Ccorruptie%E2%80%9D+OR+%E2%80%9Cfraude%E2%80%9D+OR+%E2%80%9Comkoping%E2%80%9D+OR+%E2%80%9Comgekocht%E2%80%9D+OR+%E2%80%9Csmeergeld%E2%80%9D+OR+%E2%80%9Csanctie%E2%80%9D+OR+%E2%80%9Csancties%E2%80%9D+OR+%E2%80%9Caangeklaagd%E2%80%9D+OR+%E2%80%9Cwitwassen%E2%80%9D+OR+%E2%80%9Cbeschuldigd%E2%80%9D+OR+%E2%80%9Cvervolgd%E2%80%9D+OR+%E2%80%9Cbeslaglegging%E2%80%9D+OR+%E2%80%9Cdrugs%E2%80%9D+OR+%E2%80%9Cveroordeeld%E2%80%9D+OR+%E2%80%9Caangehouden%E2%80%9D+OR+%E2%80%9Carrestatie%E2%80%9D+OR+%E2%80%9Conderzoek%E2%80%9D+OR+%E2%80%9COpenbaar+Ministerie%E2%80%9D+OR+%E2%80%9Ctoezichthouder%E2%80%9D+OR+%E2%80%9Cmisdaad%E2%80%9D+OR+%E2%80%9Cterrorisme%E2%80%9D+OR+%E2%80%9Cverduistering%E2%80%9D+OR+%E2%80%9Crechtszaak%E2%80%9D+OR+%E2%80%9Csmokkel%E2%80%9D+OR+%E2%80%9Cschikking%E2%80%9D`;
        }
        return `https://www.google.nl/search?hl=&site&q=%22${this.$parent.intake.persoonsData[personIndex].roepnaam} ${this.$parent.intake.persoonsData[personIndex].tussenvoegsel} ${this.$parent.intake.persoonsData[personIndex].achternaam}%22+AND+%22corrupt%E2%80%9D+OR+%E2%80%9Ccorruptie%E2%80%9D+OR+%E2%80%9Cfraude%E2%80%9D+OR+%E2%80%9Comkoping%E2%80%9D+OR+%E2%80%9Comgekocht%E2%80%9D+OR+%E2%80%9Csmeergeld%E2%80%9D+OR+%E2%80%9Csanctie%E2%80%9D+OR+%E2%80%9Csancties%E2%80%9D+OR+%E2%80%9Caangeklaagd%E2%80%9D+OR+%E2%80%9Cwitwassen%E2%80%9D+OR+%E2%80%9Cbeschuldigd%E2%80%9D+OR+%E2%80%9Cvervolgd%E2%80%9D+OR+%E2%80%9Cbeslaglegging%E2%80%9D+OR+%E2%80%9Cdrugs%E2%80%9D+OR+%E2%80%9Cveroordeeld%E2%80%9D+OR+%E2%80%9Caangehouden%E2%80%9D+OR+%E2%80%9Carrestatie%E2%80%9D+OR+%E2%80%9Conderzoek%E2%80%9D+OR+%E2%80%9COpenbaar+Ministerie%E2%80%9D+OR+%E2%80%9Ctoezichthouder%E2%80%9D+OR+%E2%80%9Cmisdaad%E2%80%9D+OR+%E2%80%9Cterrorisme%E2%80%9D+OR+%E2%80%9Cverduistering%E2%80%9D+OR+%E2%80%9Crechtszaak%E2%80%9D+OR+%E2%80%9Csmokkel%E2%80%9D+OR+%E2%80%9Cschikking%E2%80%9D`;
      }
      if (!this.$parent.intake.persoonsData[personIndex].tussenvoegsel) {
        return `https://www.google.nl/search?hl=&site=&q=%22${this.$parent.intake.persoonsData[personIndex].roepnaam} ${this.$parent.intake.persoonsData[personIndex].achternaam}%22+AND+%22werkzaamheden%E2%80%9D+OR+%E2%80%9CBeroep%E2%80%9D+OR+%E2%80%9Cwerk%E2%80%9D+OR+%E2%80%9Clinkedin%E2%80%9D`;
      }
      return `https://www.google.nl/search?hl=&site=&q=%22${this.$parent.intake.persoonsData[personIndex].roepnaam} ${this.$parent.intake.persoonsData[personIndex].tussenvoegsel} ${this.$parent.intake.persoonsData[personIndex].achternaam}%22+AND+%22werkzaamheden%E2%80%9D+OR+%E2%80%9CBeroep%E2%80%9D+OR+%E2%80%9Cwerk%E2%80%9D+OR+%E2%80%9Clinkedin%E2%80%9D`;
    },

    checkIban(iban) {
      const transactionIban = iban.toUpperCase().replace(/\s/g, '');
      const intakeIban = this.$parent.intake.rekeningData.iban.toUpperCase().replace(/\s/g, '');
      return transactionIban === intakeIban;
    },
    toStatus(log) {
      if (log.status === 2) {
        return 'Betaald';
      }
      return 'Fout';
    },
    totalYearIncome(person) {
      const yearIncome = person.jaarinkomen ? person.jaarinkomen : 0;
      const retirementIncome = person.pensioen && person.inkomenType === 'Pensioen'
        ? person.pensioen
        : 0;
      return (Number(yearIncome) + Number(retirementIncome));
    },
    searchPerson(index) {
      if (!this.busy) {
        this.busy = true;
        const firstName = this.$parent.intake.persoonsData[index].voornaam;
        const countryPersonIndex = this.$parent.intake.persoonsData[index].zelfdeAdres === 'Yes' ? 0 : index;

        this.sdk.searchIntakeCdd(
          this.$parent.getQueryVariable('intake'),
          index,
          firstName,
          `${
            this.$parent.intake.persoonsData[index].tussenvoegsel
              ? `${this.$parent.intake.persoonsData[index].tussenvoegsel} `
              : ''
          }${this.$parent.intake.persoonsData[index].achternaam}`,
          this.$parent.intake.persoonsData[index].geboorteDatum.substring(0, 10),
          findKey(
            this.$parent.allCountries,
            (o) => this.$parent.intake.persoonsData[countryPersonIndex].land === o,
          ),
          (response) => {
            this.$parent.files = response.data.files;
            this.modelValue[`cddResults${index}`] = response.data.result;
            this.update();
            this.busy = false;
          },
        );
      }
    },
    downloadPerson(index, sessionId, complianceId) {
      if (!this.busy) {
        this.busy = true;
        this.sdk.downloadIntakeCdd(
          this.$parent.getQueryVariable('intake'),
          index,
          sessionId,
          complianceId,
          (response) => {
            if (response.status === 200) {
              this.$parent.intakeAdmin.scopeOnDemand[`countryJSON-${index}`] = response.data.countryJSON || [];
              this.$parent.intakeAdmin.scopeOnDemand[`personJSON-${index}`] = response.data.personJSON || {};
              this.$parent.intakeAdmin.scopeOnDemand[`webJSON-${index}`] = response.data.webJSON || [];

              this.$store.state.cdd[`${index}-pep`] = {
                user: 'Automatisch',
                date: new Date().toString(),
                state: this.$parent.intakeAdmin.scopeOnDemand[`personJSON-${index}`].pep_level
                  && Number(this.$parent.intakeAdmin.scopeOnDemand[`personJSON-${index}`].pep_level) > 0
                  ? 'warning'
                  : 'valid',
                reason: this.$parent.intakeAdmin.scopeOnDemand[`personJSON-${index}`].pep_level
                  && Number(this.$parent.intakeAdmin.scopeOnDemand[`personJSON-${index}`].pep_level) > 0
                  ? 'Automatisch berekend'
                  : '',
                answer: Number(this.$parent.intakeAdmin.scopeOnDemand[`personJSON-${index}`].pep_level) > 0 ? 'Ja' : 'Nee',
              };

              let residenceResult = false;
              for (let i = 0; i < this.$parent.intakeAdmin.scopeOnDemand[`countryJSON-${index}`].length; i += 1) {
                if (this.$parent.intakeAdmin.scopeOnDemand[`countryJSON-${index}`][i].afmRisk) {
                  if (this.$parent.intakeAdmin.scopeOnDemand[`countryJSON-${index}`][i].afmRisk) {
                    residenceResult = this.$parent.intakeAdmin.scopeOnDemand[`countryJSON-${index}`][i].afmRisk;
                  }
                }
              }
              this.$store.state.cdd[`${index}-residence`] = {
                user: 'Automatisch',
                date: new Date().toString(),
                state: residenceResult ? 'warning' : 'valid',
                reason: residenceResult ? 'Automatisch berekend' : '',
                answer: residenceResult ? 'Hoog risico' : 'Laag risico',
              };

              this.$parent.files = response.data.files;
            } else {
              // eslint-disable-next-line
              window.alert(`Kan rapport niet downloaden: ${response.status} - ${
                response.data ? response.data.message : ''
              }`);
            }
            this.busy = false;
          },
        );
      }
    },
    deleteSearchResults(modelValue, index) {
      delete modelValue[`cddResults${index}`];
      this.$store.state.cdd[`${index}-residence`] = {
        state: 'none',
      };
      this.$store.state.cdd[`${index}-pep`] = {
        state: 'none',
      };
    },
    setCdd() {
      this.$parent.intakeAdmin.cddStatus.handedText = 'CDD ingediend';
      this.$parent.intakeAdmin.cddStatus.handedDate = new Date();
      this.$parent.intakeAdmin.cddStatus.handedUser = this.$store.state.name;
      this.$parent.intakeAdmin.cddStatus = clone(this.$parent.intakeAdmin.cddStatus);
      this.$parent.storeAdmin();
    },
    setStatus() {
      this.$parent.intakeAdmin.cddStatus.text = 'CDD afgerond';
      this.$parent.intakeAdmin.cddStatus.date = new Date();
      this.$parent.intakeAdmin.cddStatus.user = this.$store.state.name;
      this.$parent.intakeAdmin.cddStatus = clone(this.$parent.intakeAdmin.cddStatus);
      this.$parent.storeAdmin();
    },
    linkOriginal() {
      this.sdk.linkIntakeUser(
        this.$parent.getQueryVariable('intake'),
        this.$parent.previousEmail,
        null,
        () => {
          window.onbeforeunload = () => {};
          window.location.reload();
        },
      );
    },
    setTransactionMonitor() {
      // Set the transaction monitor value
      delete this.modelValue.transactionMonitorAmount;
      if (this.modelValue.cdd['0-riskassesment'].state === 'valid'
        || this.modelValue.cdd['0-riskassesment'].state === 'warning') {
        this.modelValue.transactionMonitorAmount = '15000';
        if (this.modelValue.cdd['0-riskassesment'].answer === 'Laag risico') {
          this.modelValue.transactionMonitorAmount = '50000';
        }
      }
    },
    update() {
      this.$emit('update:model-value', this.value);
    },
    download(file) {
      this.sdk.getIntakeFile(this.$parent.getQueryVariable('intake'), file);
    },
    remove(file) {
      if (this.$parent.status !== 'Bezig' && this.$parent.status !== 'Ingeleverd') {
        // eslint-disable-next-line
        window.alert(`Het is niet mogelijk om het bestand te verwijderen, de intake zit al al in fase ${this.$parent.status}.`);
        return;
      }
      this.$store.state.confirm.toggle({
        text: 'Wilt u dit bestand verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deleteIntakeFile(
              this.getQueryVariable('intake'),
              file,
              (response) => {
                if (response.status === 200) {
                  this.$parent.files = remove(
                    this.$parent.files,
                    (o) => o.path !== file,
                  );
                  this.update();
                } else {
                  // eslint-disable-next-line
                  window.alert('Er is een fout opgetreden bij het verwijderen van het bestand');
                }
              },
            );
          }
        },
      });
    },
  },
  mounted() {
    this.$refs.focus.focusInput();
  },
};
</script>

<style lang="scss" scoped>
  .file-row {
    padding: 10px 20px;
    background-color: #f7f8fa;
    &:hover {
      background-color: rgba($color-highlight, 0.2);
    }
    .file-button {
      float: right;
      cursor: pointer;
      color: rgba(0, 0, 0, .5);
      margin-left: 20px;
      &:hover {
        text-decoration: none;
        color: #000;
      }
    }
  }
  .mt20 {
    margin-top: 20px;
  }
  .showtoggle {
    float: right;
    cursor: pointer;
  }
  .cddDiv {
    margin-top: 20px;
    background-color: #f7f8fa;
    border-radius: 2px;
    padding: 10px;
    display: block;
    overflow: auto;
    button {
      width: 200px;
      float: right;
      line-height: 14px;
    }
    span {
      float: left;
      clear: left;
      margin-bottom: 5px;
    }
  }
  .edit {
    cursor: pointer;
    padding: 10px;
    &:hover {
      background-color: rgba($color-highlight, 0.2);
    }
  }
  .inputbox {
    background-color: #f7f8fa;
  }
  .persontable {
    td:nth-child(1), td:nth-child(3) {
      font-weight: 600;
      width: 25%;
    }
    td:nth-child(2) {
      border-right: 2px solid #fff;
      width: 25%;
    }
  }
  .card {
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
  }
</style>
